import fetch from './fetch.js'

//注册
const userRegister = (params, headers) => {
  return fetch({
    url: '/customer/register',
    method: 'post',
    params: params
  }, headers)
}


const resetPasswordByEmail = (params, headers) => {
  return fetch({
    url: '/customer/user/resetpassword/email',
    method: 'post',
    params: params
  }, headers)
}

const sendVerifyByBindingEmail = (params, headers) => {
  return fetch({
    url: '/customer/user/binding/email',
    method: 'post',
    params: params
  }, headers)
}


const resetPasswordByEmailVerify = (params, headers) => {
  return fetch({
    url: '/customer/user/resetpassword/verifycode',
    method: 'post',
    params: params
  }, headers)
}


const resetPasswordByEmailSubmit = (params, headers) => {
  return fetch({
    url: '/customer/user/resetpassword/reset',
    method: 'post',
    params: params
  }, headers)
}
// 登录
const login = (params, headers) => {
  return fetch({
    url: '/customer/login',
    method: 'post',
    params: params
  }, headers)
}

//登出
const logout = () => {
  return fetch({
    url: '/customer/logout'
  })
}



//修改用户密码
const personalInfoUpdatePassword=(params) => {
  return fetch({
    url: '/customer/user/updatePassword',
    method: 'post',
    params: params
  });
}

const personalInfoUpdateNickname=(params) => {
  return fetch({
    url: '/customer/user/updateNickname',
    method: 'post',
    params: params
  });
}

const personalInfoUpdateEmail=(params) => {
  return fetch({
    url: '/customer/user/updateEmail',
    method: 'post',
    params: params
  });
}

const personalInfoUpdateTel=(params) => {
  return fetch({
    url: '/customer/user/updateTel',
    method: 'post',
    params: params
  });
}

//获取当前登录用户数据
const getUserList = () => {
  return fetch({
    url: '/customer/user/info'
  })
}

//获取当前登录用户数据
const getUserLists = (params) => {
  return fetch({
    url: '/customer/user/list',
    method: 'get',
    params: params
  })
}

//获取菜单列表
const menuList = (params) => {
  return fetch({
    url: '/customer/user/menuList',
    method: 'get',
    params: params
  })
}

//获取菜单列表
const menuListByAccount = (params) => {
  return fetch({
    url: '/customer/user/menuListByAccount',
    method: 'get',
    params: params
  })
}

//获取菜单列表
const menuDetail = (params) => {
  return fetch({
    url: '/customer/user/menuDetail',
    method: 'get',
    params: params
  })
}
//获取菜单列表
const editMenu = (params) => {
  return fetch({
    url: '/customer/user/editMenu',
    method: 'post',
    data: params
  })
}
const createMenu = (params) => {
  return fetch({
    url: '/customer/user/createMenu',
    method: 'post',
    data: params
  })
}
const deleteMenu = (params) => {
  return fetch({
    url: '/customer/user/deleteMenu',
    method: 'post',
    data: params
  })
}
//获取菜单列表
const roleList = (params) => {
  return fetch({
    url: '/customer/user/roleList',
    method: 'get',
    params: params
  })
}

//获取菜单列表
const createRole = (params) => {
  return fetch({
    url: '/customer/user/createRole',
    method: 'post',
    data: params
  })
}
const deleteRole = (params) => {
  return fetch({
    url: '/customer/user/deleteRole',
    method: 'post',
    data: params
  })
}
//获取菜单列表
const roleEdit = (params) => {
  return fetch({
    url: '/customer/user/roleEdit',
    method: 'post',
    data: params
  })
}

//获取菜单列表
const roleDetail = (params) => {
  return fetch({
    url: '/customer/user/roleDetail',
    method: 'get',
    params: params
  })
}
//获取菜单列表
const createRoleAndMenu = (params) => {
  return fetch({
    url: '/customer/user/createRoleAndMenu',
    method: 'post',
    data: params
  })
}

//获取菜单列表
const createUserAndRoleRelation = (params) => {
  return fetch({
    url: '/customer/user/createUserAndRoleRelation',
    method: 'post',
    data: params
  })
}
//获取菜单列表
const queryUserAndRoleRelation = (params) => {
  return fetch({
    url: '/customer/user/queryUserAndRoleRelation',
    method: 'get',
    params: params
  })
}
//获取菜单列表
const queryRoleMenuRelation = (params) => {
  return fetch({
    url: '/customer/user/queryRoleMenuRelation',
    method: 'get',
    params: params
  })
}

//根据id获取用户数据
const getUserInfoById = (id) => {
  return fetch({
    url: '/customer/user/info/'+id
  })
}

//修改个人信息
const updatePersonalInfo = (params) => {
  return fetch({
    url: '/customer/user/update',
    method: 'post',
    params: params
  });
}

//修改密码
const updatePass = (params) => {
  return fetch({
      url: '/customer/user/update_pass',
      method: 'post',
      params: params
    }
  )
}

//批量修改密码判断
const batchUpdateUserPassJudge = (params) => {
  return fetch({
      url: '/customer/user/batch_update_pass_judge',
      method: 'post',
      params: params
    }
  )
}

//批量修改密码
const batchUpdateUserPass = (params) => {
  return fetch({
      url: '/customer/user/batch_update_pass',
      method: 'post',
      params: params
    }
  )
}

//pda用户修改密码
const updatePDAPass = (params) => {
  return fetch({
    url : '/customer/user/update_pass1',
    method : 'post',
    params: params
  })
}

//查询用户列表
// const userList = (params) => {
//   return fetch({
//     url: '/customer/user/list',
//     params: params
//   })
// }

//用户添加
const userAdd = (params) => {
  return fetch({
    url: '/customer/user/add',
    method: 'post',
    params: params
  });
}

//用户批量删除
const userBatchDel = (params) => {
 return fetch({
   url:'/customer/user/delete/batch',
   method: 'post',
   params: params
 });
}

//用户锁定
const userLock = (params) => {
  return fetch({
    url:'/customer/user/status',
    method: 'post',
    params: params
  });
}

//批量锁定用户
const userLock2 = (params) => {
    return fetch({
        url:'/customer/user/status/batch',
        method: 'post',
        params: params
    });
}

//批量恢复用户到正常状态
const userRestoration = (params) => {
    return fetch({
        url:'/customer/user/status/batch',
        method: 'post',
        params: params
    });
}

//用户删除
const userDel = (params) => {
  return fetch({
    url:'/customer/user/delete',
    method: 'post',
    params: params
  });
}

//用户解锁或恢复
const userRecovery = (params) => {
  return fetch({
    url:'/customer/user/status',
    method: 'post',
    params: params
  });
}

//用户密码重置
const userPassReset = (params) => {
  return fetch({
    url:'/customer/user/reset_pass',
    method: 'post',
    params: params
  });
}

//用户密码重置(批量)
const userPassReset2 = (params) => {

    return fetch({
        url:'/customer/user/reset_pass2',
        method: 'post',
        params: params
    });
}

//编辑用户
const userEdit = (params) => {
  return fetch({
    url:'/customer/user/update1',
    method: 'post',
    params: params
  });
}

//获取外部平台角色列表
const getOuterRoles = () => {
  return fetch({
    url: '/customer/role/list'
  })
}

//获取角色的权限集合
const getRolePermission = (params) => {
  return fetch({
    url: '/customer/role/getMenuAndElement',
    params: params
  })
}

//根据当前用户获取子节点列表
const getNodeChildrens = () => {
  return fetch({
    url: '/customer/org/currentChildrens'
  })
}

//获取公司所有节点列表
const getOrgNodes = () => {
  return fetch({
    url: '/customer/org/childrensByUser'
  })
}

//获取当前用户所属机构所有节点列表
const getCurrentOrgNodes = () => {
  return fetch({
    url: '/customer/org/currentChildrens'
  })
}

//增加机构信息
const addOrgInfo = (params) =>{
  return fetch({
    url: '/customer/org/addOrg',
    method: 'post',
    params: params
  })
}

// 更新机构超级管理员信息
const updateOrgSupAdmin = (params) =>{
    return fetch({
        url: '/customer/user/updateOrgSupAdmin',
        method: 'post',
        params: params
    })
}

//修改机构信息
const updateOrgInfo = (params) =>{
  return fetch({
    url: '/customer/org/updateOrg',
    method: 'post',
    params: params
  })
}

//删除节点信息
const deleteOrgInfo = (params) => {
  return fetch({
    url:'/customer/org/delOrg',
    method: 'post',
    params: params
  });
}

//获取设备分发列表
const getDeviceList = (params) => {
  return fetch({
    url:'/customer/device/list',
    params: params
  });
}

//设备绑定
const deviceBinding=(params) => {
  return fetch({
    url:'/customer/device/bindTempDevice',
    method: 'post',
    params: params
  });
}

//设备解绑
const deviceUnBinding=(params) => {
  return fetch({
    url:'/customer/device/untiedSubAccount',
    method: 'post',
    params: params
  });
}

//设备批量解绑
const deviceBatchUnbinding=(params) => {
  return fetch({
    url:'/customer/device/batchUnbunding',
    method: 'post',
    params: params
  });
}



//查询应用列表
const getAppList = (params) => {
  return fetch({
    url: '/customer/list/upload/app',
    method: 'post',
    params: params
  })
}

//上传应用信息
const updateApp = (params) => {
  return fetch({
    url : '/customer/app/update',
    method: 'post',
    params: params
  })
}
//上传应用信息
const editAppInfo = (params) => {
  return fetch({
    url : '/customer/app/edit',
    method: 'post',
    params: params
  })
}

//应用卸载
const removeApp = (params) => {
  return fetch({
    url : '/customer/app/del',
    method: 'post',
    params: params
  })
}

//应用的所有版本
const childVersionApps = (params) => {
  return fetch({
    url: '/customer/app/childversions',
    params: params
  })
}

//可发布的应用列表
const appPublishList = () => {
  return fetch({
    url: '/customer/app/publish/list'
  })
}

//发布应用
const appPublish = (params) => {
  return fetch({
    url: '/customer/app/publish',
    method: 'post',
    params: params
  })
}

const appShelfOrUnshelf = (params) => {
  return fetch({
    url : '/customer/app/shelfOrUnshelf',
    method: 'post',
    params: params
  })
}

//已发布应用和已上架应用
const appShelfList = () => {
  return fetch({
    url: '/customer/app/shelf'
  })
}



//应用获取设备类型
const getDeviceTypeListInApp = (params) => {
  return fetch({
    url : '/customer/app/typelist',
    params: params
  })
}

//新增设备信息
const addDeviceInfo = (params) => {
  return fetch({
    url : '/customer/device/addDevice',
    method: 'post',
    params: params
  })
}

//设备移动到机构
const moveToOrg = (params) => {
  return fetch({
    url : '/customer/device/moveToOrg',
    method: 'post',
    params: params
  })
}

//设置设备状态
const deviceStatusChange = (params) => {
  return fetch({
    url : '/customer/device/updateDeviceInfo',
    method: 'post',
    params: params
  })
}

//删除设备
const deviceDel = (params) => {
  return fetch({
    url : '/customer/device/delDevice',
    method: 'post',
    params: params
  })
}

//根据id查询设备信息
const getDeviceInfoById = (id) => {
  return fetch({
    url : '/customer/device/getDevInfoById/'+id,
  })
}

//根据id修改设备信息
const updateDeviceInfoById = (params) => {
  return fetch({
    url : '/customer/device/updateDeviceInfo',
    method: 'post',
    params: params
  })
}
//根据设备编号批量修改设备信息
const updateDeviceInfoByIds = (params) => {
  return fetch({
    url : '/customer/device/batchExecuteInstruction',
    method: 'post',
    params: params
  })
}

//批量删除设备
const deviceBatchDel = (params) => {
  return fetch({
    url : '/customer/device/batchDel',
    method: 'post',
    params: params
  })
}

//设备数据清理
const deviceClearData = (params) => {
  return fetch({
    url : '/customer/device/clearData',
    method: 'post',
    params: params
  })
}

//设备日志列表
const deviceLog = (params) => {
  return fetch({
    url : '/customer/device/log',
    method: 'post',
    params: params
  })
}

//设备命令发送
const deviceDiagnosisCom = (params) => {
  return fetch({
    url : '/customer/device/diagnosis',
    method: 'post',
    params: params
  })
}

//设备电子围栏批量控制
const deviceFenceBatch = (params) => {
  return fetch({
    url : '/customer/device/fenceBatch',
    method: 'post',
    params: params
  })
}

//按设备id开启或者关闭电子围栏
const deviceFenceById = (params) => {
  return fetch({
    url : '/customer/device/fenceById',
    method: 'post',
    params: params
  })
}

//获取应用配置信息
const applyConfig = () => {
  return fetch({
    url : '/customer/config/list'
  })
}

//新增应用配置信息
const addApplyConfig = (params) => {
  return fetch({
    url : '/customer/config/add',
    method: 'post',
    params: params
  })
}

//统计
const statisticDeviceStatus = () => {
  return fetch({
    url : '/customer/statistic/device_status'
  })
}

//统计设备状态
const statisticDeviceStatus2 = () => {
  return fetch({
    url : '/customer/statistic/device_status2'
  })
}

//统计
const statisticUserCount = () => {
  return fetch({
    url : '/customer/statistic/user_count'
  })
}

//统计
const statisticDeviceCount = () => {
  return fetch({
    url : '/customer/statistic/device_count'
  })
}

//统计
const statisticDeviceOperator = () => {
  return fetch({
    url : '/customer/statistic/operator'
  })
}

//统计os 版本信息
const statisticDeviceOSVersion = () => {
  return fetch({
    url : '/customer/statistic/OSVersion'
  })
}

//获取设备剩余电量和地理信息
const getDeviceEleAndAddr = (params) => {
  return fetch({
    url : '/customer/device/eleAndAddr',
    params: params
  })
}

//获取设备上已经安装的应用信息
const getDeviceApps = (params) => {
  return fetch({
    url : '/customer/device/getDeviceApps',
    params: params
  })
}

//设备屏幕锁定和解锁
const deviceScreen = (params) => {
  return fetch({
    url : '/customer/device/screen',
    method: 'post',
    params: params
  })
}
//设备重启和设备关机
const deviceSwitch = (params) => {
  return fetch({
    url : '/customer/device/deviceSwitch',
    method: 'post',
    params: params
  })
}
//设备恢复出厂
const deviceRetore = (params) => {
  return fetch({
    url : '/customer/device/deviceRetore',
    method: 'post',
    params: params
  })
}

const getConfigListByAppId = (params) => {
  return fetch({
    url : '/customer/config/add/other/text',
    params: params
  })
}

const getDeviceFunctionsById = (params) => {
  return fetch({
    url : '/customer/device/showFunctions',
    method: 'post',
    params: params
  })
}

const choiceDisableFunctions = (params) => {
  return fetch({
    url : '/customer/device/disableFunction',
    method: 'post',
    params: params
  })
}

const displayDisabledFunction = (params) => {
  return fetch({
    url : '/customer/device/showDisable',
    params: params
  })
}

const getDeviceWarns = (params) => {
  return fetch({
    url : '/customer/device/warns',
    params: params
  })
}

const getfenceInfoByNodeCode = (params) => {
  return fetch({
    url : '/customer/org/fence',
    params: params
  })
}

const searchPDAUsers = (params) => {
  return fetch({
    url : '/customer/user/search',
    params : params
  })
}

const saveFenceInfo = (params) => {
  return fetch({
    url : '/customer/org/saveFence',
    method: 'post',
    params: params
  })
}

const getDeviceBaseInfo = (params) => {
  return fetch({
    url : '/customer/device/getbaseinfo',
    params: params
  })
}

const pushMessageToOrg = (params) => {
  return fetch({
    url : '/customer/message/organization',
    method: 'post',
    params: params
  })
}

const pushMessageToUser = (params) => {
  return fetch({
    url : '/customer/message/user',
    method: 'post',
    params: params
  })
}

const sendLocateOrder = (params) => {
  return fetch({
    url : '/customer/device/locate',
    method: 'post',
    params: params
  })
}

const getDeviceAppLogs = (params) => {
  return fetch({
    url : '/customer/device/getapplogs',
    params: params
  })
}

const getOrderHis = (params) => {
  return fetch({
    url : '/customer/device/getOrderHis',
    params: params
  })
}

const listStrategy = (params) => {
  return fetch({
    url : '/customer/strategy/list',
    params : params
  })
}

const updateStrategy = (params) => {
  return fetch({
    url : '/customer/strategy/edit',
    method: 'post',
    params: params
  })
}

const deleteStrategy = (params) => {
  return fetch({
    url : '/customer/strategy/delete',
    method: 'post',
    params: params
  })
}

const addStrategy = (params) => {
  return fetch({
    url : '/customer/strategy/add',
    method: 'post',
    params: params
  })
}

const chooseStrategy = (params) => {
  return fetch({
    url : '/customer/strategy/choose',
    method: 'post',
    params: params
  })
}

const checkStrategyName = (params) => {
  return fetch({
    url : '/customer/strategy/nameExist',
    method: 'post',
    params: params
  })
}


const getEchoNode = (params) => {
  return fetch({
    url : '/customer/strategy/nodeEcho',
    method: 'post',
    params: params
  })
}

const statisticSystemVersion = () => {
  return fetch({
    url : '/customer/statistic/systemversion'
  })
}

const statisticApps = () => {
  return fetch({
    url : '/customer/statistic/getApps'
  })
}


const sendAppDiagnosisOrder = (params) => {
  return fetch({
    url : '/customer/device/appdiagnosis',
    method: 'post',
    params: params
  })
}

const deleteAppById = (params) => {
  return fetch({
    url : '/customer/app/delete/id',
    method: 'post',
    params: params
  })
}

const editApp = (params) => {
    return fetch({
        url : '/customer/app/versionEdit',
        method: 'post',
        params: params
    })
}

// 查看应用(应用上架)
const getAllVersionByAppCode = (params) => {
    return fetch({
        url : '/customer/app/getAllVersionByAppCode',
        method: 'post',
        params: params
    })
}

// 应用所有版本(应用上架)
const getAppVersions = (params) => {
    return fetch({
        url : '/customer/app/getAppVersions',
        method: 'post',
        params: params
    })
}

// 应用所有版本(应用上架)
const getAppVersions2 = (params) => {
    return fetch({
        url : '/customer/app/getReReleaseAppVersions',
        method: 'post',
        params: params
    })
}

// 当前应用最新版本机构树数据(应用上架)
const getAppOrgs = (params) => {
    return fetch({
        url : '/customer/org/appOrgs',
        method: 'post',
        params: params
    })
}

// 当前应用最新版本机构树数据(应用上架)
const shelfSubmit = (params) => {
    return fetch({
        url : '/customer/app/shelfOrUnshelf',
        method: 'post',
        params: params
    })
}

const saveTms = (params) => {
  return fetch({
    url : '/customer/tms/save',
    method: 'post',
    params: params
  })
}

const getTmsList = () => {
  return fetch({
    url : '/customer/tms/info'
  })
}

const deleteTms = (params) => {
  return fetch({
    url : '/customer/tms/delete',
    method: 'post',
    params: params
  })
}


const sendDirctoryUploadOrder = (params) => {
  return fetch({
    url : '/customer/device/path/applog',
    method: 'post',
    params: params
  })
}

const getAppConfig = (params) => {
  return fetch({
    url : '/customer/app/config',
    params: params
  })
}

const getTmsVersion = () => {
  return fetch({
    url : '/customer/system/version',
  })
}

const deleteAppConfig = (params) => {
  return fetch({
    url : '/customer/app/config/delete',
    method: 'post',
    params: params
  })
}

const checkFirstLogin = (params) => {
  return fetch({
    url : '/customer/user/isFirstLogin',
    params: params
  })
}

const changeUserNode = (params) => {
  return fetch({
    url : '/customer/user/change/node',
    method: 'post',
    params: params
  })
}

const changeNodesList = () => {
  return fetch({
    url: '/customer/user/nodes/list'
  })
}

const getCurrNode = () => {
  return fetch({
    url: '/customer/user/show/node'
  })
}

const getStrategy = (params) =>{
  return  fetch({
    url:"/customer/strategy/list",
    params:params
  })
}
const queryStrategyByTusn= (params) =>{
  return  fetch({
    url:"/customer/strategy/queryStrategyByTusn",
    method: 'post',
    params:params
  })
}

const getDeviceTypeCount = ()=>{
  return fetch({
    url:'/customer/device/countDeviceType'
  })
}

const getDeviceCallRecords = (params) => {
  return fetch({
    url : '/customer/device/getDeviceCalls',
    method: 'post',
    params: params
  })
}

const getDeviceContacts = (params) => {
  return fetch({
    url : '/customer/device/deviceContact',
    params: params
  })
}

const getMessageRecords = (params) => {
  return fetch({
    url : '/customer/device/messageRecords',
    params: params
  })
}

const delApp = (params) => {
  return fetch({
    url : '/customer/device/delApp',
    method : 'post',
    params : params
  })
}



const getAllChildAccountList = (params) =>{
  return fetch({
    url :'/customer/company/all/list',
    method : 'post',
    params : params
  })
}

const getOperateList = (params) =>{
  return fetch({
    url :'/customer/user/operate',
    params : params
  })
}

const savePermission = (params) =>{
  return fetch({
    url :'/customer/company/savePermission',
    method : 'post',
    params : params
  })
}

const addOperate = (params) =>{
  return fetch({
    url :'/customer/user/addOperate',
    method : 'post',
    params : params
  })
}

const transferAdmin = (params) =>{
  return fetch({
    url :'/customer/user/transferAdmin',
    method : 'post',
    params : params
  })
}

const operatePermission = (params) =>{
  return fetch({
    url :'/customer/company/operateSelectPermission',
    method : 'post',
    params : params
  })
}

const delOperate = (params) =>{
  return fetch({
    url :'/customer/user/delOperate',
    method : 'post',
    params : params
  })
}



const getStrategyByCode = (params) =>{
  return fetch({
    url : '/customer/strategy/queryStrategyByCode',
    method : 'post',
    params : params
  })
}

const changeOtherLanguage = (params) =>{
  return fetch({
    url : '/customer/user/change/language',
    params : params
  })
}

const getUserRolesByNodecode = (params) =>{
  return fetch({
      url : '/customer/user/getMenuAndElement',
      method : 'get',
      params : params
  })
}

const getMenuEditTree = (params) =>{
    return fetch({
        url : '/customer/user/getMenuEditTree',
        method : 'get',
        params : params
    })
}
const shelfList = (params) =>{
    return fetch({
        url : '/customer/app/hashPublishedApps/list',
        method : 'post',
        params : params
    })
}
const unshelfList = (params) =>{
    return fetch({
        url : '/customer/app/willPublishApps/list',
        method : 'post',
        params : params
    })
}

const getOrgList = () =>{
    return fetch({
        url : '/customer/org/currentAndchildOrgs',
        method : 'post'
    })
}




//修改账号上架模式
const changePutMode = (params) =>{
  return fetch({
    url:'/customer/app/changePutMode',
    method:'post',
    params:params

  })
}



//=======================leizu start=======================
const addTempDevice = (params) =>{
  return fetch({
    url : '/customer/device/addTempDevice',
    method : 'post',
    params : params
  })
}

const getTempDeviceList = (params) =>{
  return fetch({
    url : '/customer/device/getTempDevices',
    method : 'post',
    params : params
  })
}

const getTempDeviceStatus = (params) =>{
  return fetch({
    url : '/customer/device/getTempDeviceStatus',
    method : 'post',
    params : params
  })
}

const bindTempDevice = (params) =>{
  return fetch({
    url : '/customer/device/bindTempDevice',
    method : 'post',
    params : params
  })
}

const clearTempDevice = (params) =>{
  return fetch({
    url : '/customer/device/clearTempDevice',
    method : 'post',
    params : params
  })
}







const getDeviceDonateList= (params) =>{
  return fetch({
    url : '/customer/device/deviceDonateList',
    method : 'post',
    params : params
  })
}





const setGrayScale= (params) =>{
  return fetch({
    url : '/customer/app/setGrayScale',
    method : 'post',
    params : params
  })
}

const getGraySnByApp= (params) =>{
  return fetch({
    url : '/customer/app/getGraySnByApp',
    method : 'post',
    params : params
  })
}

const clearGraySn= (params) =>{
  return fetch({
    url : '/customer/app/clearGraySn',
    method : 'post',
    params : params
  })
}

const addTempDevice2= (params) =>{
  return fetch({
    url : '/customer/device/batchAddTempDevice2',
    method : 'post',
    params : params
  })
}

const delTempDevice=(params) =>{
  return fetch({
    url : '/customer/device/delTempDevice',
    method : 'post',
    params : params
  })
}

const addDeviceGroup= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/addDeviceGroup',
    method : 'post',
    params : params
  })
}

const updateDeviceGroup= (params) =>{
    return fetch({
      url : '/customer/deviceGroup/updateDeviceGroup',
      method : 'post',
      params : params
    })
  }
const moveGroupToOtherGroup= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/moveGroupToOther',
    method : 'post',
    params : params
  })
}

const moveGroupsToOtherOneGroup= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/moveGroupsToOtherOne',
    method : 'post',
    params : params
  })
}

const deleteDeviceGroup= (params) =>{
    return fetch({
      url : '/customer/deviceGroup/deleteDeviceGroup',
      method : 'post',
      params : params
    })
  }

const listDeviceGroup= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/listDeviceGroup',
    method : 'post',
    params : params
  })
}


const listDeviceGroupTree= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/listDeviceGroupTree',
    method : 'post',
    params : params
  })
}
const listGroupDeviceByCode= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/listGroupDeviceByCode',
    method : 'post',
    params : params
  })
}

const listGroupInfo= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/listGroupInfo',
    method : 'post',
    params : params
  })
}


const countOnlineStatus=(params) =>{
  return fetch({
    url:'/customer/deviceGroup/countOnlineStatus',
    method:'post',
    params:params
  })
}

const queryOccupyScreenApps=(params) =>{
  return fetch({
    url:'/customer/sysCustomization/queryOccupyScreenApps',
    method:'get',
    params:params
  })
}



















const listAppsByCurrentAccount= () =>{
  return fetch({
    url : '/customer/app/listAppsByCurrentAccount',
    method : 'post',
  })
}

const confirmDeleteSingle= (params) =>{
  return fetch({
    url : '/customer/app/confirmDeleteSingle',
    method : 'post',
    params : params
  })
}

const confirmBatchDelete= (params) =>{
  return fetch({
    url : '/customer/app/confirmBatchDelete',
    method : 'post',
    params : params
  })
}




const getDeviceGroupDeviceAddress= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/address',
    method : 'post',
    params : params
  })
}

const getDeviceGroupDeviceFence= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/queryDeviceFence',
    method : 'post',
    params : params
  })
}

const updateDeviceGroupDeviceFence= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/updateDeviceFence',
    method : 'post',
    params : params
  })
}

const queryDeviceRestoreData= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/deviceRestore/list',
    method : 'post',
    params : params
  })
}




const unInstallDeviceApp= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/unInstallDeviceApp',
    method : 'post',
    params : params
  })
}

const unInstallDeviceAppForGroups= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/unInstallDeviceAppForGroups',
    method : 'post',
    params : params
  })
}


const getUnInstallAppDataClockDetail= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/getUnInstallAppDataClockDetail',
    method : 'post',
    params : params,
    async : false,
  })
}


/////////

// 添加应用卸载
const addUnInstallDeviceApp = (unInstallDeviceApp) => {
  return fetch({
    url : '/customer/deviceSetting/addUnInstallDeviceApp',
    method: 'post',
    data: unInstallDeviceApp
  })
}

// 编辑应用卸载
const editUnInstallDeviceAppContent = (unInstallDeviceApp) => {
  return fetch({
    url : '/customer/deviceSetting/editUnInstallDeviceAppContent',
    method: 'post',
    data: unInstallDeviceApp
  })
}

// 获取应用卸载列表
const queryUnInstallDeviceAppList = (unInstallDeviceApp) => {
  return fetch({
    url : '/customer/deviceSetting/queryUnInstallDeviceAppList',
    method: 'post',
    data: unInstallDeviceApp
  })
}

// 获取应用卸载
const queryUnInstallDeviceAppDetail = (unInstallDeviceApp) => {
  return fetch({
    url : '/customer/deviceSetting/queryUnInstallDeviceAppDetail',
    method: 'post',
    data: unInstallDeviceApp
  })
}
// 推送应用卸载
const pushUnInstallDeviceApp = (unInstallDeviceApp) => {
  return fetch({
    url : '/customer/deviceSetting/pushUnInstallDeviceApp',
    method: 'post',
    data: unInstallDeviceApp
  })
}

// 推送应用卸载
const pushUnInstallDeviceAppBySnList = (unInstallDeviceApp) => {
  return fetch({
    url : '/customer/deviceSetting/pushUnInstallDeviceAppBySnList',
    method: 'post',
    data: unInstallDeviceApp
  })
}
// 删除应用卸载
const deleteUnInstallDeviceApp = (configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteUnInstallDeviceApp',
    method: 'post',
    data: configCodes
  })
}
// 获取应用卸载的推送范围
const queryUnInstallDeviceAppPushRange = (unInstallAppQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryUnInstallDeviceAppPushRange',
    method: 'post',
    data: unInstallAppQuery
  })
}
// 获取应用卸载的完成情况
const queryUnInstallDeviceAppFinishStatus = (unInstallAppQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryUnInstallDeviceAppFinishStatus',
    method: 'post',
    data: unInstallAppQuery
  })
}

///////



// 添加消息推送
const addMessagePush = (messagePush) => {
  return fetch({
    url : '/customer/deviceSetting/addMessagePush',
    method: 'post',
    data: messagePush
  })
}

// 编辑消息推送
const editMessagePushContent = (messagePush) => {
  return fetch({
    url : '/customer/deviceSetting/editMessagePushContent',
    method: 'post',
    data: messagePush
  })
}

// 获取消息推送列表
const queryMessagePushList = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryMessagePushList',
    method: 'post',
    data: messageQuery
  })
}

// 获取消息推送
const queryMessagePushDetail = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryMessagePushDetail',
    method: 'post',
    data: messageQuery
  })
}
// 推送消息推送
const pushMessagePush = (messagePush) => {
  return fetch({
    url : '/customer/deviceSetting/pushMessagePush',
    method: 'post',
    data: messagePush
  })
}

// 推送消息推送
const pushMessagePushBySnList = (messagePush) => {
  return fetch({
    url : '/customer/deviceSetting/pushMessagePushBySnList',
    method: 'post',
    data: messagePush
  })
}
// 删除消息推送
const deleteMessagePush = (configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteMessagePush',
    method: 'post',
    data: configCodes
  })
}
// 获取消息推送的推送范围
const queryMessagePushPushRange = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryMessagePushPushRange',
    method: 'post',
    data: messageQuery
  })
}
// 获取消息推送的完成情况
const queryMessagePushFinishStatus = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryMessagePushFinishStatus',
    method: 'post',
    data: messageQuery
  })
}



///////



// 添加开机logo
const addBootLogo = (bootLogo) => {
  return fetch({
    url : '/customer/deviceSetting/addBootLogo',
    method: 'post',
    data: bootLogo
  })
}

// 编辑开机logo
const editBootLogoContent = (bootLogo) => {
  return fetch({
    url : '/customer/deviceSetting/editBootLogoContent',
    method: 'post',
    data: bootLogo
  })
}

// 获取开机logo列表
const queryBootLogoList = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryBootLogoList',
    method: 'post',
    data: messageQuery
  })
}

// 获取开机logo
const queryBootLogoDetail = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryBootLogoDetail',
    method: 'post',
    data: messageQuery
  })
}
// 推送开机logo
const pushBootLogo = (bootLogo) => {
  return fetch({
    url : '/customer/deviceSetting/pushBootLogo',
    method: 'post',
    data: bootLogo
  })
}

// 推送开机logo
const pushBootLogoBySnList = (bootLogo) => {
  return fetch({
    url : '/customer/deviceSetting/pushBootLogoBySnList',
    method: 'post',
    data: bootLogo
  })
}
// 删除开机logo
const deleteBootLogo = (configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteBootLogo',
    method: 'post',
    data: configCodes
  })
}
// 获取开机logo的推送范围
const queryBootLogoPushRange = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryBootLogoPushRange',
    method: 'post',
    data: messageQuery
  })
}
// 获取开机logo的完成情况
const queryBootLogoFinishStatus = (messageQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryBootLogoFinishStatus',
    method: 'post',
    data: messageQuery
  })
}




const getRecordOrderById= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/getRecordOrderById',
    method : 'post',
    params : params
  })
}

const switchDevice= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/switchDevice',
    method : 'post',
    params : params
  })
}

const deviceRing= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/deviceRing',
    method : 'post',
    params : params
  })
}

const switchRetry= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/switchRetry',
    method : 'post',
    params : params
  })
}


const batchDisableDevice= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/batchDisableDevice',
    method : 'post',
    params : params
  })
}

const batchDisableDeviceGroups= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/batchDisableDeviceGroups',
    method : 'post',
    params : params
  })
}


const batchMoveDevice= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/batchMoveDevice',
    method : 'post',
    params : params
  })
}

const listUnDoneOrder= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/listUnDoneOrder',
    method : 'post',
    params : params
  })
}

//=======================leizu end=========================

const listAppDetailsInfo= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/listAppDetailsInfo',
    method : 'post',
    params : params
  })
}

const getDvcMonitorInfoById= (params) =>{
  return fetch({
    url : '/customer/deviceGroup/getDvcMonitorInfoById',
    method : 'post',
    params : params
  })
}

//=======================xz end=========================

const saveCompanyInfo = (params) =>{
  return fetch({
    url : '/customer/company/saveinfo',
    method : 'post',
    params : params
  })
}

const queryCompanyInfo = () =>{
  return fetch({
    url : '/customer/company/querycompanyinfo',
    method : 'post',
  })
}



const checkEmail = (params) =>{
  return fetch({
    url : '/customer/user/checkEmail',
    method : 'get',
    params : params
  })
}



const appToNormalEdition = (params) =>{
  return fetch({
    url : '/customer/app/transfer/official',
    method : 'post',
    params : params
  })
}
const appGetHuiDetail = (params) =>{
  return fetch({
    url : '/customer/app/notOnShelfAppDetail',
    method : 'get',
    params : params
  })
}


const appRestoreIssue = (params) =>{
  return fetch({
    url : '/customer/app/recover/publish',
    method : 'post',
    params : params
  })
}

const appPauseIssue = (params) =>{
  return fetch({
    url : '/customer/app/pause/publish',
    method : 'post',
    params : params
  })
}

const appNormalUpgrade = (params) =>{
  return fetch({
    url : '/customer/app/normal/publish',
    method : 'post',
    params : params
  })
}

const appCoverUpgrade = (params) =>{
  return fetch({
    url : '/customer/app/cover/upgrade',
    method : 'post',
    params : params
  })
}

const appGrayUpgrade = (params) =>{
  return fetch({
    url : '/customer/app/gray/upgrade',
    method : 'post',
    params : params
  })
}


//获取未上架应用
const notOnShelfApp = (params) =>{
  return fetch({
    url:'/customer/app/notOnShelfAppList',
    method:'post',
    params:params
  })
}
const resendEmail = (params) =>{
  return fetch({
    url : '/customer/user/resendEmail',
    method : 'get',
    params : params
  })
}
const getIndustryType = (params) => {
  return fetch({
    url: '/customer/list/industry',
    method:'post',
  })
}

const getDvcType = (params) => {
  return fetch({
    url: '/customer/list/dvcType',
    method:'post',
  })
}

//获取已上架应用
const onShelfApp = (params) =>{
  return fetch({
    url:'/customer/app/onShelfAppList',
    method:'post',
    params:params

  })
}

//获取已上架应用
const onShelfAppForAppDeploy = (params) =>{
  return fetch({
    url:'/customer/app/onShelfAppListForAppDeploy',
    method:'post',
    params:params

  })
}


//批量上架应用
const batchOnShelfApp = (params) =>{
  return fetch({
    url : '/customer/app/batchOnShelfApp',
    method : 'post',
    params : params
  })
}

//批量下架应用
const batchUnShelfApp = (params) =>{
  return fetch({
    url : '/customer/app/batchUnShelfApp',
    method : 'post',
    params : params
  })
}


//编辑部署
const editAppDeploy = (params) =>{
  return fetch({
    url:'/customer/appManage/editAppDeploy',
    method:'post',
    params:params

  })
}

//删除部署
const deleteAppDeploy = (params) =>{
  return fetch({
    url:'/customer/appManage/deleteAppDeploy',
    method:'post',
    params:params
  })
}

//查询已经部署的应用
const queryHasDeployedApps = (params) =>{
  return fetch({
    url:'/customer/appManage/queryHasDeployedApps',
    method:'get',
    params:params

  })
}



//查询部署记录
const queryAppDeploy = (params) =>{
  return fetch({
    url:'/customer/appManage/queryAppDeploy',
    method:'get',
    params:params
  })
}

const queryAppDeployOperateRecord = (params) =>{
  return fetch({
    url:'/customer/configRecord/queryRecord',
    method:'get',
    params:params
  })
}

const queryPushRangeByCode = (params) =>{
  return fetch({
    url:'/customer/appManage/queryPushRangeByCode',
    method:'get',
    params:params
  })
}



























const queryApnPushRangeByCode = (params) =>{
  return fetch({
    url:'/customer/apnSettings/queryPushRangeByCode',
    method:'get',
    params:params
  })
}

const deleteApnSettings = (params) =>{
  return fetch({
    url:'/customer/apnSettings/deleteApnSetting',
    method:'post',
    params:params
  })
}



const queryAppDeployHasPushedGroups = (params) =>{
  return fetch({
    url:'/customer/appManage/queryAppDeployHasPushedGroups',
    method:'get',
    params:params
  })
}























//自动安装状态改变
const autoInstallChange = (params) =>{
  return fetch({
    url : '/customer/app/autoInstallChange',
    method : 'post',
    params : params
  })
}

//获取设备应用信息
const getDvcAppInfo = (params) =>{
  return fetch({
    url : '/customer/device/getDvcApp',
    method : 'get',
    params : params
  })
}


const getChannelStatus = (params) =>{
  return fetch({
    url : '/customer/app/query/status',
    method : 'get',
    params : params
  })
}


const getAppVersionList = (params) =>{
  return fetch({
    url : '/customer/app/query/manage',
    method : 'get',
    params : params
  })
}

const getAppBaseInfo = (params) =>{
  return fetch({
    url : '/customer/app/details',
    method : 'get',
    params : params
  })
}







const returnParentManage = () =>{
  return fetch({
    url : '/customer/subAccount/returnParentAccount',
  })
}

const getOrderRecordList = (params) =>{
  return fetch({
    url : '/customer/order/record/list',
    method : 'get',
    params : params
  })
}



const getAllDeviceAddressInfo = (p) =>{
  return fetch({
    url : '/customer/deviceMap/displayAllDeviceAddress',
    method : 'post',
    params : p
  })
}



const getDeviceMapAddressBySearchKey = (params) =>{
  return fetch({
    url : '/customer/deviceMap/displayAllDeviceAddressQuery',
    method : 'post',
    params : params
  })
}

const getClpRecordList = (params) =>{
  return fetch({
    url : '/customer/clear/pwd/list',
    method : 'get',
    params : params
  })
}

const sendClpOrder = (params) =>{
  return fetch({
    url : '/customer/dvc/clp',
    method : 'post',
    params : params
  })
}

const sendRecOrder = (params) =>{
  return fetch({
    url : '/customer/dvc/recover',
    method : 'post',
    params : params
  })
}

const getAllDeviceType = () =>{
  return fetch({
    url : '/customer/dataCenter/getDeviceTypeList',
    method : 'post',
  })
}

const getAllDeviceTypeAddress = () =>{
  return fetch({
    url : '/customer/dataCenter/getDeviceTypeListAddress',
    method : 'post',
  })
}

const getDeviceLifeCycleSum = () =>{
  return fetch({
    url:"/customer/dataCenter/getDeviceLifeCycleSum",
    method:"post"
  })
}

const getDeviceLifeCycleList = (params) =>{
  return fetch({
    url : '/customer/dataCenter/getDeviceLifeCycleList',
    method : 'post',
    params : params
  })
}

const getListMyDeviceList = (params)=>{
  return fetch({
    url:'/customer/device/myDevice',
    method:'get',
    params:params
  })
}

const queryDeviceLogRecord = (params)=>{
  return fetch({
    url:'/customer/logManage/logRecord/list',
    method:'get',
    params:params
  })
}

const queryLogDevice = (params)=>{
  return fetch({
    url:'/customer/logManage/device/list',
    method:'get',
    params:params
  })
}

const addDeviceLogRecord = (params) => {
  return fetch({
    url : '/customer/logManage/add/logRecord',
    method: 'post',
    data: params
  })
}

const updateDeviceLogRecordStatus = (params) => {
  return fetch({
    url : '/customer/logManage/update/logStatus',
    method: 'post',
    data: params
  })
}


const queryDeviceUploadLogFile = (params) =>{
  return fetch({
    url : '/customer/logManage/file/path',
    method : 'get',
    params : params
  })
}

const extractDvcLogs = (params) =>{
  return fetch({
    url : '/customer/deviceGroup/extractDvcLogs',
    method : 'post',
    params : params
  })
}

const extractDvcLogsForGroups = (params) =>{
  return fetch({
    url : '/customer/deviceGroup/extractDvcLogsForGroups',
    method : 'post',
    params : params
  })
}

const queryDvcType=()=>{
  return fetch({
    url:'/customer/logManage/device/Type',
    method:'get',
  })
}

const getClpOrderStatus = (params)=>{
  return fetch({
    url:'/customer/clp/order/sn',
    method:'get',
    params:params
  })
}

const getRecOrderStatus = (params)=>{
  return fetch({
    url:'/customer/recover/order/sn',
    method:'get',
    params:params
  })
}

const fileDistribution = (params) =>{
  return fetch({
    url : '/customer/deviceGroup/fileDistribution',
    method : 'post',
    params : params
  })
}

const fileDistributionForGroups = (params) =>{
  return fetch({
    url : '/customer/deviceGroup/fileDistributionForGroups',
    method : 'post',
    params : params
  })
}


const handlerUninstallAppRevoke = (params) =>{
  return fetch({
    url : '/customer/cancel/order',
    method : 'post',
    params : params
  })
}

const getCompanyInfoIsInput = () =>{
  return fetch({
    url : '/customer/companyinfo/input',
    method : 'post',
  })
}


const queryDeviceConfig = (param) =>{
  return fetch({
    url:'/customer/deviceConfig/query',
    method:'post',
    params:param
  })
}

const deviceConfigStart = (params) =>{
  return fetch({
    url:'/customer/deviceConfig/startEffect',
    method:'post',
    params: params,
  })
}

const addOrEditDeviceConfig = (params) =>{
  return fetch({
    url:'/customer/deviceConfig/save',
    method:'post',
    params:params,
  })
}

const batchSaveDeviceConfig = (params) =>{
  return fetch({
    url:'/customer/deviceConfig/batchSave',
    method:'post',
    params:params,
  })
}

const getCustomDeskList = (params) =>{
  return fetch({
    url : '/customer/sysCustomization/getCustomDeskList',
    method : 'get',
    params : params,
  })
}

const getCustomDeskName = (params) =>{
  return fetch({
    url : '/customer/sysCustomization/getCustomDeskName',
    method : 'get',
    params : params,
  })
}






const getCustomDetail = (params) =>{
  return fetch({
    url : '/customer/sysCustomization/getCustomDeskDetail',
    method : 'get',
    params : params,
  })
}

const selectCustomDesk = (params) =>{
  return fetch({
    url : '/customer/sysCustomization/selectCustomDesk',
    method : 'post',
    params : params,
  })
}

const selectDefaultDesk = (params) =>{
  return fetch({
    url : '/customer/sysCustomization/selectDefaultDesk',
    method : 'post',
    params : params,
  })
}







const remoteWifiSetting = (params) => {
  return fetch({
    url : '/customer/deviceGroup/batchRemoteWifiConfiguration',
    method: 'post',
    params: params
  })
}

const remoteWifiSettingForGroups = (params) => {
  return fetch({
    url : '/customer/deviceGroup/batchRemoteWifiConfigurationForGroups',
    method: 'post',
    params: params
  })
}


const addOrEditRemark = (params) => {
  return fetch({
    url : '/customer/addOrEdit/remark',
    method : 'post',
    params: params
  })
}

const appQueryThink = (params) => {
  return fetch({
    url : '/customer/app/query/think',
    params: params
  })
}

const shelfAppGrouped = (params) => {
  return fetch({
    url : '/customer/app/groupedShelfApp',
    method : 'post',
    params: params
  })
}

const listDeviceGroupTreeByAppId = (params) => {
  return fetch({
    url : '/customer/app/modifyGroup',
    method : 'post',
    params: params
  })
}

const bindTempDevice2 = (params) => {
  return fetch({
    url : '/customer/groupManage/bindDevice',
    method : 'post',
    params: params
  })
}


const addWifiConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/addWifiConfig',
    method: 'post',
    params: params
  })
}


const queryManufacturers = (params) => {
  return fetch({
    url : '/customer/manufacturer/queryManufacturers',
    method: 'get',
    params: params
  })
}

const addManufacturerDvcType = (params) => {
  return fetch({
    url : '/customer/manufacturer/addManufacturerDvcType',
    method: 'get',
    params: params
  })
}

const addManufacturer = (params) => {
  return fetch({
    url : '/customer/manufacturer/addManufacturer',
    method: 'get',
    params: params
  })
}

const deleteManufacturerDvcType = (params) => {
  return fetch({
    url : '/customer/manufacturer/deleteManufacturerDvcType',
    method: 'get',
    params: params
  })
}

const deleteManufacturer = (params) => {
  return fetch({
    url : '/customer/manufacturer/deleteManufacturer',
    method: 'get',
    params: params
  })
}


const queryAllManufacturer = (params) => {
  return fetch({
    url : '/customer/manufacturer/queryAllManufacturer',
    method: 'get',
    params: params
  })
}

const queryChildDvcType = (params) => {
  return fetch({
    url : '/customer/manufacturer/queryChildDvcType',
    method: 'get',
    params: params
  })
}


const listOrgDevices = (params) => {
  return fetch({
    url : '/customer/device/deviceList',
    method: 'get',
    params: params
  })
}

const listOrgDevicesWithoutPage = (params) => {
  return fetch({
    url : '/customer/device/deviceListWithoutPage',
    method: 'get',
    params: params
  })
}

const deviceDetail = (params) => {
  return fetch({
    url : '/customer/device/deviceDetail',
    method: 'post',
    data: params
  })
}

const queryDeviceInfoDetail = (params) => {
  return fetch({
    url : '/customer/device/queryDeviceInfoDetail',
    method: 'get',
    params: params,

  })
}

const queryDeviceHardwareDetections = (params) => {
  return fetch({
    url : '/customer/device/queryHardwareDetections',
    method: 'get',
    params: params,

  })
}


const queryDevicePower = (params) => {
  return fetch({
    url : '/customer/device/queryDevicePower',
    method: 'get',
    params: params
  })
}

const queryRecentDevicePower = (params) => {
  return fetch({
    url : '/customer/device/queryRecentDevicePower',
    method: 'get',
    params: params
  })
}

const queryOrgDeviceCount = (params) => {
  return fetch({
    url : '/customer/device/queryOrgDeviceCount',
    method: 'get',
    params: params
  })
}




const queryDeviceInstalledApps = (params) => {
  return fetch({
    url : '/customer/device/queryDeviceInstalledApps',
    method: 'get',
    params: params,
    async: false
  })
}

const queryDeviceOrders = (params) => {
  return fetch({
    url : '/customer/device/queryDeviceOrders',
    method: 'get',
    params: params,
    async: false
  })
}

const queryDeviceStatus = (params) => {
  return fetch({
    url : '/customer/device/getDeviceStatus',
    method: 'get',
    params: params,
    async: false
  })
}


const sendDeviceOrder = (params) => {
  return fetch({
    url : '/customer/device/deviceOrderSwitch',
    method: 'get',
    params: params,
    async: false
  })
}

const queryDeviceTaskLogs = (params) => {
  return fetch({
    url : '/customer/device/queryDeviceTaskLogs',
    method: 'get',
    params: params,
    async: false
  })
}

const queryAppParam = (params) => {
  return fetch({
    url : '/customer/appParamConfig/queryAppParam',
    method: 'post',
    params: params,
    async: false
  })
}

const addFileDistribution = (params) => {
  return fetch({
    url : '/customer/deviceSetting/addFileDistribution',
    method: 'post',
    params: params,
    async: false
  })
}

const editFileDistribution = (params) => {
  return fetch({
    url : '/customer/deviceSetting/editFileDistribution',
    method: 'post',
    data: params,
  })
}

const pushFileDistributionConfig = (params,orgIds) => {
  return fetch({
    url : '/customer/deviceSetting/pushFileDistributionConfig',
    method: 'post',
    data: params,
  })
}

const pushFileDistributionBySnList = (params,orgIds) => {
  return fetch({
    url : '/customer/deviceSetting/pushFileDistributionBySnList',
    method: 'post',
    data: params,
  })
}

const queryCurrentDistribution = (params) => {
  return fetch({
    url : '/customer/deviceSetting/queryCurrentDistribution',
    method: 'post',
    params: params,
    async: false
  })
}


const queryFunctionSettings = (params) => {
  return fetch({
    url : '/customer/deviceSetting/queryFunctionSettings',
    method: 'get',
    params: params,
    async: false
  })
}




const addAppParamConfig = (params) => {
  return fetch({
    url : '/customer/appParamConfig/addAppParamConfig',
    method: 'post',
    data: params,
  })
}

const editAppParamConfig = (params) => {
  return fetch({
    url : '/customer/appParamConfig/editParamConfig',
    method: 'post',
    data:params,
  })
}

const queryCurrentParamConfig = (params) => {
  return fetch({
    url : '/customer/appParamConfig/queryCurrentParamConfig',
    method: 'get',
    params: params,
    async: false
  })
}


const pushParamConfig = (params,orgIds) => {
  return fetch({
    url : '/customer/appParamConfig/pushParamConfig',
    method: 'post',
    params: params,
    data:orgIds,
    async: false
  })
}

const pushParamConfigBySnList = (params) => {
  return fetch({
    url : '/customer/appParamConfig/pushParamConfigBySnList',
    method: 'post',
    data:params,
  })
}

const getHasPushedOrganizations = (params) => {
  return fetch({
    url : '/customer/configRule/getHasPushedOrganizations',
    method: 'get',
    params: params,
  })
}


const getConfigRulePushRecord = (params) => {
  return fetch({
    url : '/customer/configRule/getConfigRulePushRecord',
    method: 'post',
    params: params,
    async: false
  })
}

const getHasPushedOrgNames = (params) => {
  return fetch({
    url : '/customer/configRule/getHasPushedOrgNames',
    method: 'get',
    params: params,
  })
}

const getHasPushedSns = (params) => {
  return fetch({
    url : '/customer/configRule/getHasPushedSns',
    method: 'get',
    params: params,
  })
}

const getHasPushedSnsWithoutPage = (params) => {
  return fetch({
    url : '/customer/configRule/getHasPushedSnsWithoutPage',
    method: 'post',
    data: params,
  })
}

const queryNotFinishSn = (params) => {
  return fetch({
    url : '/customer/configRule/queryNotFinishSn',
    method: 'post',
    params: params,
    async: false
  })
}

const deleteAppParamConfig = (params,configCodes) => {
  return fetch({
    url : '/customer/appParamConfig/deleteAppParamConfig',
    method: 'post',
    params: params,
    data:configCodes,
    async: false
  })
}

const deleteFileDistribution = (params,configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteFileDistribution',
    method: 'post',
    params: params,
    data:configCodes,
    async: false
  })
}

const deleteFunctionSetting = (params,configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteFunctionSetting',
    method: 'post',
    params: params,
    data:configCodes,
    async: false
  })
}



const queryDistributionTable = (params) => {
  return fetch({
    url : '/customer/deviceSetting/queryDistributionTable',
    method: 'post',
    params: params,
    async: false
  })
}


















const editWifiConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/editWifiConfig',
    method: 'post',
    params: params
  })
}

const delWifiConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/delWifiConfig',
    method: 'post',
    params: params
  })
}

const listWifiPushGroup = (params) => {
  return fetch({
    url : '/customer/remoteConfig/pushed/deviceGroup',
    method: 'post',
    params: params
  })
}

const getConfigPushGroup = (params) => {
  return fetch({
    url : '/customer/remoteConfig/getConfigPushGroup',
    method: 'post',
    params: params
  })
}


const batchPushWifiConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/batchPushedWifiConfig',
    method: 'post',
    params: params
  })
}

const queryWifiConfigById = (params) => {
  return fetch({
    url : '/customer/remoteConfig/queryWifiConfigById',
    method: 'post',
    params: params
  })
}

const queryWifiConfigList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/wifiConfigList',
    method: 'post',
    params: params
  })
}
const getWifiName = (params) => {
  return fetch({
    url : '/customer/remoteConfig/getWifiSetName',
    method: 'get',
    params: params
  })
}


const queryApnSettingsList = (params) => {
  return fetch({
    url : '/customer/apnSettings/queryApnSettings',
    method: 'post',
    params: params
  })
}

const addApnSetting = (params) => {
  return fetch({
    url : '/customer/apnSettings/addApnSetting',
    method: 'post',
    params: params
  })
}

const editApnSetting = (params) => {
  return fetch({
    url : '/customer/apnSettings/editApnSetting',
    method: 'post',
    params: params
  })
}




const queryApnPushedGroup = (params) => {
  return fetch({
    url : '/customer/apnSettings/queryPushedGroups',
    method: 'get',
    params: params
  })
}

const pushApnSetting = (params) => {
  return fetch({
    url : '/customer/apnSettings/pushApnSetting',
    method: 'post',
    params: params
  })
}




const queryConfigUnFinshDeviceList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/unFinshDeviceList',
    method: 'post',
    params: params
  })
}

const exportConfigUnFinshDeviceList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/export/unFinshDeviceList',
    method: 'post',
    params: params
  })
}

const queryConfigPushDeviceGroupList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/pushDeviceGroupList',
    method: 'post',
    params: params
  })
}
const queryFcConfigPushDeviceGroupList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/pushfcDeviceGroupList',
    method: 'post',
    params: params
  })
}

const queryFcConfigUnFinshDeviceList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/unfcFinshDeviceList',
    method: 'post',
    params: params
  })
}

const exportFcConfigUnFinshDeviceList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/export/unfcFinshDeviceList',
    method: 'post',
    params: params
  })
}

const delFunctionConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/delFuncftonConfig',
    method: 'post',
    params: params
  })
}

const deviceGroupExport = (params) => {
  return fetch({
    url : '/customer/groupManage/exportGroup',
    method : 'post',
    params: params
  })
}

const addTempDeviceInGroup = (params) => {
  return fetch({
    url : '/customer/groupManage/addTempDevice',
    method : 'post',
    params: params
  })
}

const exportBindTempDevice = () => {
  return fetch({
    url : '/customer/groupManage/bindDevice2',
    method : 'post',
  })
}

const switchDeviceForGroups = (params) => {
  return fetch({
    url : '/customer/deviceGroup/switchDeviceForGroups',
    method : 'post',
    params: params
  })
}


const addCustomDesk = (params) => {
  return fetch({
    url : '/customer/sysCustomization/addCustomDesk',
    method: 'post',
    params: params
  })
}

const delCustomDesk = (params) => {
  return fetch({
    url : '/customer/sysCustomization/deleteCustomDesk',
    method: 'post',
    params: params
  })
}

const getHasPushGroups = (params) => {
  return fetch({
    url : '/customer/desk/has/push',
    method: 'get',
    params: params
  })
}

const showHasPushGroups = (params) => {
  return fetch({
    url : '/customer/show/pushed/deviceGroup',
    method: 'get',
    params: params
  })
}

const batchPushCusDesk = (params) => {
  return fetch({
    url : '/customer/remoteConfig/batchPushedCusDesk',
    method: 'post',
    params: params
  })
}

const editCustomDesk = (params) => {
  return fetch({
    url : '/customer/deviceSetting/editCustomDeskConfig',
    method: 'post',
    data: params
  })
}

//  新增功能设置
const addFunctionConfig = (params) => {
  return fetch({
    url : '/customer/deviceSetting/addFunctionSetting',
    method: 'post',
    params: params
  })
}

//  编辑功能设置
const editFunctionConfig = (params) => {
  return fetch({
    url : '/customer/deviceSetting/editFunctionSetting',
    method: 'post',
    data: params
  })
}

const pushFunctionSetting = (params,orgIds) => {
  return fetch({
    url : '/customer/deviceSetting/pushFunctionSetting',
    method: 'post',
    data: params
  })
}

const pushFunctionSettingBySnList = (params,orgIds) => {
  return fetch({
    url : '/customer/deviceSetting/pushFunctionSettingBySnList',
    method: 'post',
    data: params
  })
}


//  新增wifi白名单
const addWifiWhitelist = (params) => {
  return fetch({
    url : '/customer/remoteConfig/add/wifiWhitelistConfig',
    method: 'post',
    params: params
  })
}

//  查询wifi白名单列表
const queryWifiWhiteList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/query/wifiWhitelistConfig',
    method: 'post',
    params: params
  })
}

//  查询wifi白名单详情
const queryWifiWhiteListByCode = (params) => {
  return fetch({
    url : '/customer/remoteConfig/query/wifiWhitelistConfigByCode',
    method: 'post',
    params: params
  })
}

// 修改wifi白名单
const editWifiWhitelist = (params) => {
  return fetch({
    url : '/customer/remoteConfig/edit/wifiWhitelistConfig',
    method: 'post',
    params: params
  })
}

//获取已推送分组
const listWifiWhitelistPushGroup = (params) => {
  return fetch({
    url : '/customer/remoteConfig/wifiWhitelist/pushed/deviceGroup',
    method: 'post',
    params: params
  })
}

//批量推送分组
const batchPushWifiWhitelistConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/batchPushedWifiWhitelistConfig',
    method: 'post',
    params: params
  })
}

//查询推送分组
const queryWifiWhitelistPushRanage = (params) => {
  return fetch({
    url : '/customer/remoteConfig/wifiWhitelist/pushDeviceGroupList',
    method: 'post',
    params: params
  })
}

//查询推送分组
const queryWifiWhitelistPushRanageByCompanyCode = () => {
  return fetch({
    url : '/customer/remoteConfig/wifiWhitelist/push/deviceGroupList',
    method: 'post',
  })
}

//查询分组推送wifi
const queryGroupPushWifiSsid = (params) => {
  return fetch({
    url : '/customer/remoteConfig/wifiWhitelist/deviceGroup/ssidList',
    method: 'post',
    params: params
  })
}

//查询分组推送wifi带条件
const queryGroupPushWifiSsidBySsidName = (params) => {
  return fetch({
    url : '/customer/remoteConfig/wifiWhitelist/deviceGroup/ssidList/query',
    method: 'post',
    params: params
  })
}

//  查询wifi白名单列表
const delWifiWhiteList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/del/wifiWhitelistConfig',
    method: 'post',
    params: params
  })
}


//流量管理
const flowUseListTable = (params) => {
  return fetch({
    url : '/customer/flowManage/companyFlowTable/list',
    method: 'post',
    params: params
  })
}

const flowUseListLine = (params) =>{
  return fetch({
    url : '/customer/flowManage/companyFlow/list',
    method: 'post',
    params: params
  })


}

const exportCompanyFlow = (params) => {
  return fetch({
    url : '/customer/flowManage/companyFlow/export',
    method: 'post',
    params: params
  })
}

const queryAppFlowList = (params) => {
  return fetch({
    url : '/customer/flowManage/appFlow/list',
    method: 'post',
    params: params
  })
}


const getAppAverage = (params) => {
  return fetch({
    url : '/customer/flowManage/appFlow/flowAverage',
    method: 'post',
    params: params
  })
}

const exportAppFlow = (params) => {
  return fetch({
    url : '/customer/flowManage/deviceAppFlow/export',
    method: 'post',
    params: params
  })
}


const getDvcGroupFlowAll = (params) => {
  return fetch({
    url : '/customer/flowManage/deviceGroupFlow/overAll',
    method: 'post',
    params: params
  })
}


const getDvcGroupFlowList = (params) => {
  return fetch({
    url : '/customer/flowManage/deviceGroupFlow/list',
    method: 'post',
    params: params
  })
}

const exportGroupFlow = (params) => {
  return fetch({
    url : '/customer/flowManage/deviceGroupFlow/exportList',
    method: 'post',
    params: params
  })
}

const getDvcGroupFlowListDetail = (params) => {
  return fetch({
    url : '/customer/flowManage/deviceGroupFlow/deviceFlow',
    method: 'post',
    params: params
  })
}

const getDvcGroupFlowListDetailOne = (params) => {
  return fetch({
    url : '/customer/flowManage/deviceGroupFlow/one',
    method: 'post',
    params: params
  })
}

const exportDvcGroupFlowListDetailOne = (params) => {
  return fetch({
    url : '/customer/flowManage/deviceGroupFlow/export/deviceFlow',
    method: 'post',
    params: params
  })
}

//消息推送
const dvcMessagePush = (params) => {
  return fetch({
    url : '/customer/deviceGroup/bootLogo',
    method: 'post',
    params: params
  })
}
//消息推送(设备组)
const dvcMessagePushForGroups = (params) => {
  return fetch({
    url : '/customer/deviceGroup/bootLogoForGroups',
    method: 'post',
    params: params
  })
}


//开机logo开机logo
const dvcBootLogo = (params) => {
  return fetch({
    url : '/customer/deviceGroup/bootLogo',
    method: 'post',
    params: params
  })
}
//开机logo(设备组)
const dvcBootLogoForGroups = (params) => {
  return fetch({
    url : '/customer/deviceGroup/bootLogoForGroups',
    method: 'post',
    params: params
  })
}



//  修改功能设置
const updateFunctionConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/function/update',
    method: 'post',
    params: params
  })
}
//  新增功能设置
const queryFcConfigList = (params) => {
  return fetch({
    url : '/customer/remoteConfig/function/list',
    method: 'get',
    params: params
  })
}//  推送功能设置
const pushFcConfig = (params) => {
  return fetch({
    url : '/customer/remoteConfig/function/push',
    method: 'post',
    params: params
  })
}
//  疫情-身份登记报表
const getTemperatureInfo = (params) => {
  return fetch({
    url : '/idregui/report/getTemperatureInfo',
    method: 'get',
    params: params
  })
}

//获取机构树
const queryOrgAndSubOrg = (params) => {
  return fetch({
    url : '/customer/org/selfAndSub',
    method: 'get',
    params: params
  })
}
// 创建子机构（商户）
const createOrgOrMerchant = (params) => {
  return fetch({
    url : '/customer/org/create',
    method: 'post',
    data: params
  })
}

// 获取机构（商户）详情
const queryOrgDetailById = (params) => {
  return fetch({
    url : '/customer/org/detail',
    method: 'get',
    params: params
  })
}

// 保存机构（商户）修改
const updateOrgOrMerchant = (params) => {
  return fetch({
    url : '/customer/org/updateOrgOrMerchant',
    method: 'post',
    data: params
  })
}

// 删除机构（商户）
const deleteOrgById = (params) => {
  return fetch({
    url : '/customer/org/delete',
    method: 'post',
    data: params
  })
}

//审核申请
const addAppApply = (params) => {
  return fetch({
    url : '/customer/app/apply/check',
    method: 'post',
    params: params
  })
}

//撤销申请
const cancelAppCheck = (params) => {
  return fetch({
    url : '/customer/app/apply/cancel',
    method: 'post',
    params: params
  })
}

//重新申请
const reAppCheck = (params) => {
  return fetch({
    url : '/customer/re/apply/check',
    method: 'post',
    params: params
  })
}

//获取审核模式
const queryCheckMode = (params) => {
  return fetch({
    url : '/customer/app/check/mode',
    method: 'post',
    params: params
  })
}

//查询审核列表
const queryCheckList = (params) => {
  return fetch({
    url : '/customer/app/check/list',
    method: 'post',
    params: params
  })
}
// 单件入库
const addDeviceOne = (device) => {
  return fetch({
    url : '/customer/deviceRepository/addOne',
    method: 'post',
    data: device
  })
}

// 库存移动
const storageMove = (storageMove) => {
  return fetch({
    url : '/customer/deviceRepository/storageMove',
    method: 'post',
    data: storageMove
  })
}
// 设备绑定
const deviceBind = (deviceBind) => {
  return fetch({
    url : '/customer/deviceRepository/deviceBind',
    method: 'post',
    data: deviceBind
  })
}

// 设备解绑
const unbindDevice = (unbindDevice) => {
  return fetch({
    url : '/customer/deviceRepository/unbindDevice',
    method: 'post',
    data: unbindDevice
  })
}

// 获取指定机构的终端仓库的设备
const queryRepositoryDevice = (searchCondition) => {
  return fetch({
    url : '/customer/deviceRepository/deviceList',
    method: 'post',
    data: searchCondition
  })
}
// 获取日志记录
const queryLog = (logQuery) => {
  return fetch({
    url : '/customer/log/queryLog',
    method: 'post',
    data: logQuery
  })
}
// 获取日志记录
const queryOptions = () => {
  return fetch({
    url : '/customer/log/queryOptions',
    method: 'get',
  })
}

//查询单个应用信息
const queryAppInfo = (params) => {
  return fetch({
    url : '/customer/query/app/info',
    method: 'post',
    params: params
  })
}

const updateAppCheckStatus = (params) => {
  return fetch({
    url : '/customer/update/check/status',
    method: 'post',
    params: params
  })
}

const updateAppCheckMode = (params) => {
  return fetch({
    url : '/customer/update/check/mode',
    method: 'post',
    params: params
  })
}

const queryAppCheckBlacklist = (params) => {
  return fetch({
    url : '/customer/list/check/balcklist',
    method: 'post',
    params: params
  })
}

const addCheckBlacklist = (params) => {
  return fetch({
    url : '/customer/add/check/balcklist',
    method: 'post',
    data: params
  })
}

const delCheckBlacklist = (params) => {
  return fetch({
    url : '/customer/del/check/balcklist',
    method: 'post',
    params: params
  })
}

const listHasShelfApps = (params) => {
  return fetch({
    url : '/customer/has/shelf/app',
    method: 'post',
    params: params
  })
}

const listNoShelfApps = (params) => {
  return fetch({
    url : '/customer/no/shelf/app',
    method: 'post',
    params: params
  })
}

const appShelfToAll = (params) => {
  return fetch({
    url : '/customer/shelf/to/all',
    method: 'post',
    params: params
  })
}

const appUnshelf = (params) => {
  return fetch({
    url : '/customer/app/unshelf',
    method: 'post',
    params: params
  })
}

const appAndOrg = (params) => {
  return fetch({
    url : '/customer/app/push/info',
    method: 'post',
    params: params
  })
}

const appShelfOrg = (params) => {
  return fetch({
    url : '/customer/shelf/to/org',
    method: 'post',
    params: params
  })
}

const childOrgIds = (params) => {
  return fetch({
    url : '/customer/org/child/id',
    method: 'post',
    params: params
  })
}

const appThinkQuery = (params) => {
  return fetch({
    url : '/customer/app/think/query',
    method: 'post',
    params: params
  })
}

// const appDownloadCount = (params) => {
//   return fetch({
//     url : '/customer/query/app/download',
//     method: 'post',
//     params: params
//   })
// }

const listInsideApp = (params) => {
  return fetch({
    url : '/customer/inside/app/list',
    method: 'post',
    params: params
  })
}

const editInsideApp = (params) => {
  return fetch({
    url : '/customer/inside/app/edit',
    method: 'post',
    params: params
  })
}

const listHistoryInsideApp = (params) => {
  return fetch({
    url : '/customer/inside/app/history',
    method: 'post',
    params: params
  })
}


const delInsideApp = (params) => {
  return fetch({
    url : '/customer/inside/app/del',
    method: 'post',
    params: params
  })
}

const willDeployApp = (params) => {
  return fetch({
    url : '/customer/will/app/deploy',
    method: 'post',
    params: params
  })
}

const queryAppDeploy1 = (params) => {
  return fetch({
    url : '/customer/appDeploy/queryAppDeploy1',
    method: 'post',
    data: params
  })
}

//添加部署记录
const addAppDeploy = (params) =>{
  return fetch({
    url:'/customer/add/app/deploy',
    method:'post',
    params:params

  })
}

//添加部署记录
const updateAppDeploy = (params) =>{
  return fetch({
    url:'/customer/appDeploy/updateAppDeploy',
    method:'post',
    data:params
  })
}

const listAppDeploy = (params) => {
  return fetch({
    url : '/customer/list/app/deploy',
    method: 'post',
    params: params
  })
}

const pushAppDeploy = (params) => {
  return fetch({
    url : '/customer/push/app/deploy',
    method: 'post',
    data: params
  })
}

const pushAppDeployBySnList = (params) => {
  return fetch({
    url : '/customer/push/app/deployBySnList',
    method: 'post',
    data: params
  })
}

const delAppDeploy = (params) => {
  return fetch({
    url : '/customer/push/app/delete',
    method: 'post',
    data: params
  })
}

const queryRecordDetail = (params) => {
  return fetch({
    url : '/customer/app/deploy/detail',
    method: 'post',
    params: params
  })
}

const queryPushRange = (params) => {
  return fetch({
    url : '/customer/config/push/range',
    method: 'post',
    params: params
  })
}

const queryConfigProgress = (params) => {
  return fetch({
    url : '/customer/config/progress',
    method: 'post',
    params: params
  })
}

const queryHasPushOrgIds = (params) => {
  return fetch({
    url : '/customer/config/push/org/ids',
    method: 'post',
    params: params
  })
}


//OTA 查询OS
const queryOSList = (params) => {
  return fetch({
    url : '/customer/pgmVersion/queryPgm',
    method: 'post',
    params: params
  })
}

//OTA 删除OS
const delOs = (params) => {
  return fetch({
    url : '/customer/pgmVersion/batchDeletePgm',
    method: 'post',
    params: params
  })
}

//OTA 查询类型
const queryAllByType = () => {
  return fetch({
    url : '/customer/pgmVersion/queryAllByType',
    method: 'post',
  })
}

//OTA 上传包
const uploadOS = (params,headers) => {
  return fetch({
    url : '/customer/pgmVersion/upload',
    method: 'post',
    params: params
  }, headers)
}

//OTA 生效/推送
const changeStatus = (params) => {
  return fetch({
    url : '/customer/pgmVersion/changeOsStatus',
    method: 'post',
    params: params
  })
}

//OTA 查询SN
const findRegulation = (params) => {
  return fetch({
    url : '/customer/sn/findRegulation',
    method: 'post',
    params: params
  })
}

//OTA 添加SN
const addReg = (regModel) => {
  return fetch({
    url : '/customer/sn/addReg',
    method: 'post',
    data: regModel
  })
}

//OTA 获取常量
const getConst = () => {
  return fetch({
    url : '/customer/sn/getConst',
    method: 'post',
  })
}

//OTA 查询ORG规则
const getOrgs = (params) => {
  return fetch({
    url : '/customer/org/queryOrgByOsId',
    method: 'post',
    params: params
  })
}

//OTA 保存ORG规则
const savaOrgs = (params) => {
  return fetch({
    url : '/customer/org/saveOrgRegular',
    method: 'post',
    params: params
  })
}

//OTA 查询升级记录
const getRecords = (finishedNoticeQuery) => {
  return fetch({
    url : '/customer/pgmVersion/queryRecords',
    method: 'post',
    data: finishedNoticeQuery
  })
}

// 创建WIFI配置
const addWifiSetting = (wifiSetting) => {
  return fetch({
    url : '/customer/deviceSetting/addWifiSetting',
    method: 'post',
    data: wifiSetting
  })
}

// 编辑WIFI配置
const editWifiSetting = (wifiSetting) => {
  return fetch({
    url : '/customer/deviceSetting/editWifiSetting',
    method: 'post',
    data: wifiSetting
  })
}

// 获取WIFI配置列表
const queryWifiSettingList = (wifiQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryWifiSettingList',
    method: 'post',
    data: wifiQuery
  })
}
// 推送WIFI配置
const pushWifiSetting = (wifiSetting) => {
  return fetch({
    url : '/customer/deviceSetting/pushWifiSetting',
    method: 'post',
    data: wifiSetting
  })
}

const pushWifiSettingBySnList = (wifiSetting) => {
  return fetch({
    url : '/customer/deviceSetting/pushWifiSettingBySnList',
    method: 'post',
    data: wifiSetting
  })
}
// 获取WIFI配置推送范围
const queryWifiSettingPushRange = (wifiQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryWifiSettingPushRange',
    method: 'post',
    data: wifiQuery
  })
}

// 获取WIFI配置推送完成情况
const queryFinishStatus = (handleStatusQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryFinishStatus',
    method: 'post',
    data: handleStatusQuery
  })
}
// 获取WIFI配置详情
const queryWifiConfigDetail = (configCode) => {
  return fetch({
    url : '/customer/deviceSetting/queryWifiConfigDetail',
    method: 'get',
    params: configCode
  })
}

// 获取WIFI配置详情
const deleteWifiSetting = (configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteWifiSetting',
    method: 'post',
    data: configCodes
  })
}
// 获取WIFI配置推送记录
const queryPushRecord = (query) => {
  return fetch({
    url : '/customer/configOperate/queryPushRecord',
    method: 'post',
    data: query
  })
}
// 重新推送失败的配置
const rePush = (selectObj) => {
  return fetch({
    url : '/customer/deviceSetting/rePushFailConfig',
    method: 'post',
    data: selectObj
  })
}
// 添加APN配置
const addApnConfig = (apnConfig) => {
  return fetch({
    url : '/customer/deviceSetting/addApnConfig',
    method: 'post',
    data: apnConfig
  })
}

// 添加APN配置
const editApnConfig = (apnConfig) => {
  return fetch({
    url : '/customer/deviceSetting/editApnConfig',
    method: 'post',
    data: apnConfig
  })
}

// 获取APN配置列表
const queryApnConfigList = (apnQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryApnConfigList',
    method: 'post',
    data: apnQuery
  })
}

// 获取APN配置
const queryApnDetail = (apnQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryApnDetail',
    method: 'post',
    data: apnQuery
  })
}
// 推送APN配置
const pushApnConfig = (apnPush) => {
  return fetch({
    url : '/customer/deviceSetting/pushApnConfig',
    method: 'post',
    data: apnPush
  })
}

// 推送APN配置
const pushApnConfigBySnList = (apnPush) => {
  return fetch({
    url : '/customer/deviceSetting/pushApnConfigBySnList',
    method: 'post',
    data: apnPush
  })
}
// 删除APN配置
const deleteApnConfig = (configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteApnConfig',
    method: 'post',
    data: configCodes
  })
}
// 获取APN配置的推送范围
const queryApnConfigPushRange = (apnQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryApnConfigPushRange',
    method: 'post',
    data: apnQuery
  })
}
// 获取APN配置的完成情况
const queryApnFinishStatus = (apnQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryApnFinishStatus',
    method: 'post',
    data: apnQuery
  })
}

// 添加自定义桌面配置
const addCustomDeskConfig = (customDesk) => {
  return fetch({
    url : '/customer/deviceSetting/addCustomDeskConfig',
    method: 'post',
    data: customDesk
  })
}

// 获取自定义桌面配置
const queryCustomDeskConfigList = (customDeskQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryCustomDeskConfigList',
    method: 'post',
    data: customDeskQuery
  })
}

// 获取自定义桌面配置
const queryCustomDesk = (customDeskQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryCustomDesk',
    method: 'post',
    data: customDeskQuery
  })
}

// 获取自定义桌面配置的推送范围
const queryCustomDeskConfigPushRange = (customDeskQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryCustomDeskConfigPushRange',
    method: 'post',
    data: customDeskQuery
  })
}
// 推送自定义桌面配置
const pushCustomDeskConfig = (configPush) => {
  return fetch({
    url : '/customer/deviceSetting/pushCustomDeskConfig',
    method: 'post',
    data: configPush
  })
}
// 推送自定义桌面配置
const pushCustomDeskConfigBySnList = (configPush) => {
  return fetch({
    url : '/customer/deviceSetting/pushCustomDeskConfigBySnList',
    method: 'post',
    data: configPush
  })
}
// 删除自定义桌面配置
const deleteCustomDeskConfig = (configCodes) => {
  return fetch({
    url : '/customer/deviceSetting/deleteCustomDeskConfig',
    method: 'post',
    data: configCodes
  })
}

// 获取自定义桌面配置的完成情况
const queryCustomDeskFinishStatus = (handleStatusQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryCustomDeskFinishStatus',
    method: 'post',
    data: handleStatusQuery
  })
}

// 获取设备围栏
const queryDeviceFenceList = (par) => {
  return fetch({
    url : '/customer/deviceSetting/deviceFenceList',
    method: 'get',
    params: par

  })
}

const addDeviceFence = (param) => {
  return fetch({
    url : '/customer/deviceSetting/add/device/fence',
    method: 'post',
    data: param
  })
}

const editDeviceFence = (param) => {
  return fetch({
    url : '/customer/deviceSetting/edit/device/fence',
    method: 'post',
    data: param
  })
}

const deleteDeviceFence = (configList) => {
  return fetch({
    url : '/customer/deviceSetting/delete/device/fence',
    method: 'post',
    data: configList
  })
}

const pushDeviceFence = (deviceFenceSetting) => {
  return fetch({
    url : '/customer/deviceSetting/push/device/fence',
    method: 'post',
    data: deviceFenceSetting
  })
}

const pushDeviceFenceConfigBySnList = (deviceFenceSetting) => {
  return fetch({
    url : '/customer/deviceSetting/pushDeviceFenceConfigBySnList',
    method: 'post',
    data: deviceFenceSetting
  })
}

// 获取自定义桌面配置的完成情况
const queryDeviceFenceFinishStatus = (handleStatusQuery) => {
  return fetch({
    url : '/customer/deviceSetting/queryDeviceFenceFinishStatus',
    method: 'post',
    data: handleStatusQuery
  })
}

// 获取自定义桌面配置的完成情况
const queryAlreadyPushOrg = (params) => {
  return fetch({
    url : '/customer/deviceSetting/push/already/org',
    method: 'get',
    params: params
  })
}

// 记录下载操作日志
const recordDownloadDeviceLog = (sn) => {
  return fetch({
    url : '/customer/deviceSetting/recordDownloadDeviceLog',
    method: 'get',
    params: sn
  })
}
// 批量删除设备
const deviceDeleteBash = (snList) => {
  return fetch({
    url : '/customer/deviceRepository/deviceDeleteBash',
    method: 'post',
    data: snList
  })
}

// 批量删除设备
const operateDate = (operateDate) => {
  return fetch({
    url : '/customer/deviceRepository/operateDate',
    method: 'post',
    data: operateDate
  })
}

// 获取上传文件进度
const quryUploadProcess = (operateDate) => {
  return fetch({
    url : '/customer/pgmVersion/queryProcess',
    method: 'post',
    data: operateDate
  })
}

// 是否开启了OSS文件上传
const ifUploadOss = (operateDate) => {
  return fetch({
    url : '/customer/pgmVersion/ifUploadOss',
    method: 'post',
    data: operateDate
  })
}

//平台设置
const queryFlowAndPownerSetting = () => {
  return fetch({
    url : '/customer/platformSetting/query/flowAndPower',
    method: 'post',
  })
}

const updateFlowAndPownerSetting = (params) => {
  return fetch({
    url : '/customer/platformSetting/update/flowAndPower',
    method: 'post',
    params:params
  })
}

const queryDataCacheSetting = () => {
  return fetch({
    url : '/customer/platformSetting/query/dataCacheSetting',
    method: 'post',
  })
}

const updateDataCacheSetting = (params) => {
  return fetch({
    url : '/customer/platformSetting/update/dataCacheSetting',
    method: 'post',
    params:params
  })
}

// 获取霸屏应用时可选应用
const getAppForOccupyScreen = (params) => {
  return fetch({
    url : '/customer/occupyScreen/getAppForOccupyScreen',
    method: 'get',
    params:params
  })
}

// 添加霸屏应用配置项
const addOccupyScreen = (param) => {
  return fetch({
    url : '/customer/occupyScreen/addOccupyScreen',
    method: 'post',
    data: param
  })
}

// 编辑霸屏应用
const editOccupyScreen = (param) => {
  return fetch({
    url : '/customer/occupyScreen/editOccupyScreen',
    method: 'post',
    data: param
  })
}

// 获取在霸屏应用中已经推送过的OrgId集合
const queryHasPushOrgIdsForOccupyScreen = (param) => {
  return fetch({
    url : '/customer/occupyScreen/queryHasPushOrgIdsForOccupyScreen',
    method: 'get',
    params: param
  })
}

// 获取霸屏应用列表
const queryOccupyScreen = (param) => {
  return fetch({
    url : '/customer/occupyScreen/queryOccupyScreen',
    method: 'get',
    params: param
  })
}

// 获取霸屏应用详情
const queryOccupyScreenDetail = (param) => {
  return fetch({
    url : '/customer/occupyScreen/queryOccupyScreenDetail',
    method: 'get',
    params: param
  })
}

// 推送霸屏应用
const pushOccupyScreen = (param) => {
  return fetch({
    url : '/customer/occupyScreen/pushOccupyScreen',
    method: 'post',
    data: param
  })
}
// 推送霸屏应用
const pushOccupyScreenBySnList = (param) => {
  return fetch({
    url : '/customer/occupyScreen/pushOccupyScreenBySnList',
    method: 'post',
    data: param
  })
}

// 获取霸屏应用完成度详情
const queryFinishStatusOccupy = (param) => {
  return fetch({
    url : '/customer/occupyScreen/queryFinishStatusOccupy',
    method: 'post',
    data: param
  })
}

// 删除霸屏应用
const deleteOccupyScreenSetting = (param) => {
  return fetch({
    url : '/customer/occupyScreen/deleteOccupyScreenSetting',
    method: 'post',
    data: param
  })
}

// 设备批量解绑
const deviceBatchUnbindReal = (param) => {
  return fetch({
    url : '/customer/deviceRepository/deviceBatchUnbindReal',
    method: 'post',
    data: param
  })
}

// 获取设备生命周期列表
const queryDeviceLifeCycleList = (param) => {
  return fetch({
    url : '/customer/deviceRepository/queryDeviceLifeCycleList',
    method: 'get',
    params: param
  })
}
// 获取设备生命周期中的总览和设备类型列表
const queryAbstractAndDvcType = (param) => {
  return fetch({
    url : '/customer/deviceRepository/queryAbstractAndDvcType',
    method: 'get',
    params: param
  })
}

// 导出Excel
const exportExcelForLifeCycle = (param) => {
  return fetch({
    url : '/customer/deviceRepository/exportDeviceLifeCycleList',
    method: 'get',
    params: param
  })
}
//开机动画
const queryBootAnimation=(param)=>{
  return fetch({
    url : '/customer/query/boot/animation',
    method: 'get',
    params: param
  })
}

const createBootAnimation=(param)=>{
  return fetch({
    url : '/customer/add/boot/animation',
    method: 'post',
    data: param
  })
}
const updateBootAnimation=(param)=>{
  return fetch({
    url : '/customer/update/boot/animation',
    method: 'post',
    data: param
  })
}

const deleteBootAnimation=(param)=>{
  return fetch({
    url : '/customer/del/boot/animation',
    method: 'post',
    data: param
  })
}

const pushBootAnimation=(param)=>{
  return fetch({
    url : '/customer/push/boot/animation',
    method: 'post',
    data: param
  })
}
const pushBootAnimationBySnList=(param)=>{
  return fetch({
    url : '/customer/push/boot/animation/snList',
    method: 'post',
    data: param
  })
}
const apiList = {
  exportExcelForLifeCycle,
  queryAbstractAndDvcType,

  // 获取设备生命周期
  queryDeviceLifeCycleList,

  // 设备批量解绑
  deviceBatchUnbindReal,

  // 霸屏应用
  getAppForOccupyScreen,
  addOccupyScreen,
  editOccupyScreen,
  queryHasPushOrgIdsForOccupyScreen,
  queryOccupyScreen,
  queryOccupyScreenDetail,
  pushOccupyScreen,
  pushOccupyScreenBySnList,
  queryFinishStatusOccupy,
  deleteOccupyScreenSetting,

  //OTA
  queryOSList,
  delOs,
  queryAllByType,
  uploadOS,
  changeStatus,
  findRegulation,
  addReg,
  getConst,
  getOrgs,
  savaOrgs,
  getRecords,

  listDeviceGroupTreeByAppId,
  shelfAppGrouped,
  selectDefaultDesk,
  selectCustomDesk,
  getCustomDetail,
  getCustomDeskList,
  getCustomDeskName,
  listUnDoneOrder,
  getAllDeviceType,
  getAllDeviceTypeAddress,
  resendEmail,
  checkFirstLogin,
  checkEmail,
  getAllChildAccountList,
  savePermission,
  getOperateList,
  addOperate,
  transferAdmin,
  operatePermission,
  delOperate,
  personalInfoUpdatePassword,
  personalInfoUpdateNickname,
  personalInfoUpdateEmail,
  personalInfoUpdateTel,
  //=======================leizu start=======================
  addTempDevice,//添加单台临时设备
  getTempDeviceList,//获得临时设备列表
  getTempDeviceStatus,//获得临时设备统计数量
  bindTempDevice,//批量绑定设备
  clearTempDevice,//清空临时设备
  getDeviceDonateList,//获得设备可赠送列表
  setGrayScale,//调整设置灰度范围
  getGraySnByApp,//得到此应用灰度部署的设备编号集合
  clearGraySn,//根据应用id清空灰度部署设备
  addTempDevice2,//批量插入临时设备（用于显示之前发布的）
  delTempDevice,
  addDeviceGroup,//添加设备组
  updateDeviceGroup,//修改设备组
  moveGroupToOtherGroup,//分组移动到分组
  moveGroupsToOtherOneGroup,//分组移动到分组（针对多对一设备组）
  deleteDeviceGroup,//删除设备组
  listDeviceGroup,//查询设备组列表
  listDeviceGroupTree,//查询设备组列表
  listGroupDeviceByCode,//根据设备组编号查询设备组内设备信息
  listGroupInfo,//查询设备组信息

  listAppDetailsInfo, // 查询设备应用详情
  getDvcMonitorInfoById, //通过设备id查询监控信息
  listAppsByCurrentAccount,//查询当前账号下的所有应用
  unInstallDeviceApp,//批量操作-卸载应用
  unInstallDeviceAppForGroups,//批量操作-卸载应用(针对设备组)
  getUnInstallAppDataClockDetail,//得到卸载应用闹钟详情
  getRecordOrderById,//根据指令记录唯一id查询记录信息
  switchDevice,//批量操作-设备关机重启
  switchRetry,//关机重启重试操作
  deviceRing,

  // 添加应用卸载配置
  addUnInstallDeviceApp,

  editUnInstallDeviceAppContent,
  // 获取应用卸载配置列表
  queryUnInstallDeviceAppList,
  queryUnInstallDeviceAppDetail,
  // 应用卸载配置推送
  pushUnInstallDeviceApp,
  // Sn配置推送
  pushUnInstallDeviceAppBySnList,
  // 删除应用卸载配置
  deleteUnInstallDeviceApp,
  // 获取应用卸载配置的推送范围
  queryUnInstallDeviceAppPushRange,
  // 获取应用卸载配置完成情况
  queryUnInstallDeviceAppFinishStatus,

  // 添加消息推送配置
  addMessagePush,
  editMessagePushContent,
  // 获取消息推送配置列表
  queryMessagePushList,
  queryMessagePushDetail,
  // 消息推送配置推送
  pushMessagePush,
  // Sn配置推送
  pushMessagePushBySnList,
  // 删除消息推送配置
  deleteMessagePush,
  // 获取消息推送配置的推送范围
  queryMessagePushPushRange,
  // 获取消息推送配置完成情况
  queryMessagePushFinishStatus,



  // 添加开机logo配置
  addBootLogo,
  editBootLogoContent,
  // 获取开机logo配置列表
  queryBootLogoList,
  queryBootLogoDetail,
  // 开机logo配置推送
  pushBootLogo,
  // Sn配置推送
  pushBootLogoBySnList,
  // 删除开机logo配置
  deleteBootLogo,
  // 获取开机logo配置的推送范围
  queryBootLogoPushRange,
  // 获取开机logo配置完成情况
  queryBootLogoFinishStatus,

  confirmDeleteSingle,//确认删除单台临时设备
  confirmBatchDelete,//批量删除临时设备
  //=======================leizu end=========================

  getDeviceGroupDeviceAddress,
  getDeviceGroupDeviceFence,
  updateDeviceGroupDeviceFence,
  queryDeviceRestoreData,


  batchDisableDevice,//设备禁用
  batchDisableDeviceGroups,//设备禁用(针对设备组)
  userRegister,
  login,
  logout,
  resetPasswordByEmail,
  resetPasswordByEmailVerify,
  sendVerifyByBindingEmail,
  resetPasswordByEmailSubmit,
  returnParentManage,


  getAllDeviceAddressInfo,
  getDeviceMapAddressBySearchKey,


  getCompanyInfoIsInput,


  queryRoleMenuRelation,
  queryUserAndRoleRelation,
  createUserAndRoleRelation,
  createRoleAndMenu,
  roleEdit,
  deleteRole,
  createRole,
  roleDetail,
  roleList,
  deleteMenu,
  createMenu,
  editMenu,
  menuDetail,
  menuList,
  menuListByAccount,
  getUserLists,
  getUserList,
  getUserInfoById,
  updatePersonalInfo,
  batchUpdateUserPass,
  batchUpdateUserPassJudge,
  updatePass,
  updatePDAPass,
  // userList,
  userAdd,
  userEdit,
  userBatchDel,
  userLock, //单个用户锁定
  userLock2, //批量锁定用户
  userDel,
  userRecovery,
  userPassReset,  //单个重置密码
  userPassReset2, //批量重置密码
  userRestoration,//批量恢复用户到正常状态
  getOuterRoles,
  getRolePermission,
  getNodeChildrens,
  getOrgNodes,
  getCurrentOrgNodes,
  addOrgInfo,
  updateOrgSupAdmin, // 更新机构超级管理员信息
  updateOrgInfo,
  deleteOrgInfo,
  getStrategy,
  getAppList,
  updateApp,
  editAppInfo,
  removeApp,
  childVersionApps,
  appPublishList,
  appPublish,
  appShelfOrUnshelf,
  appShelfList,
  getDeviceList,
  getDeviceTypeCount,
  addDeviceInfo,
  moveToOrg,
  deviceStatusChange,
  deviceDel,
  deviceBinding,//设备绑定子账户
  deviceUnBinding,//
  deviceBatchUnbinding,//设备批量解绑
  getDeviceInfoById,
  updateDeviceInfoById,
  updateDeviceInfoByIds,
  deviceBatchDel,
  deviceClearData,
  deviceLog,
  deviceDiagnosisCom,
  deviceFenceBatch,
  deviceFenceById,
  applyConfig,
  addApplyConfig,
  statisticDeviceStatus,
  statisticDeviceStatus2,
  statisticUserCount,
  statisticDeviceCount,
  statisticDeviceOperator,
  statisticDeviceOSVersion,
  statisticSystemVersion,
  statisticApps,
  getDeviceEleAndAddr,
  getDeviceApps,
  deviceScreen,
  deviceSwitch,
  deviceRetore,
  getConfigListByAppId,
  getDeviceFunctionsById,
  choiceDisableFunctions,
  displayDisabledFunction,
  getDeviceWarns,
  getfenceInfoByNodeCode,
  searchPDAUsers,
  saveFenceInfo,
  pushMessageToOrg,
  pushMessageToUser,
  sendLocateOrder,
  getDeviceAppLogs,
  getOrderHis,
  getDeviceBaseInfo,
  listStrategy,
  updateStrategy,
  deleteStrategy,
    addStrategy,
  getStrategyByCode,
  chooseStrategy,
  sendAppDiagnosisOrder,
  editApp,// 编辑应用信息(应用列表)
  getAllVersionByAppCode,// 查看应用(应用上架)
  getAppVersions,// 初始化应用分发弹窗数据( 获取当前应用所有版本 )
  getAppVersions2,// 初始化应用分发弹窗数据( 获取当前应用所有版本 )
  getAppOrgs,// 初始化应用分发弹窗数据( 获取最新版本机构树数据 )
  shelfSubmit,// 上架
  deleteAppById,
  saveTms,
  getTmsList,
  deleteTms,
  sendDirctoryUploadOrder,
  getAppConfig,
  deleteAppConfig,
  getTmsVersion,

  changeUserNode,
  changeNodesList,
  getCurrNode,
  getDeviceCallRecords,
  getDeviceContacts,
  getMessageRecords,
  delApp,
  getEchoNode,
  checkStrategyName,
  changeOtherLanguage,
  getUserRolesByNodecode,
  getMenuEditTree,
  queryStrategyByTusn,
  getDeviceTypeListInApp,
  shelfList, // 查询已发布应用
  unshelfList, // 查询未发布应用
  getOrgList, // 已上架页面机构下拉框


  saveCompanyInfo,//保存公司信息
  queryCompanyInfo,
  changePutMode,

  //=======================penn start=========================
  appGetHuiDetail,
  appToNormalEdition, //应用转正式版
  appRestoreIssue, //应用恢复发行
  appPauseIssue,  //应用暂停发行
  appNormalUpgrade, //应用正常升级
  appCoverUpgrade, //应用覆盖升级
  appGrayUpgrade,  //应用灰度升级
  getIndustryType, // 查询行业信息
  getDvcType,//设备类型信息
  getChannelStatus, //获取渠道状态信息
  getAppVersionList, //获取应用版本列表信息
  getAppBaseInfo,

  extractDvcLogs,//设备日志提取
  extractDvcLogsForGroups,//设备日志提取（针对设备组）
  getOrderRecordList, //获取指令记录列表
  getClpRecordList, //获取清除锁屏密码列表
  sendClpOrder, //发送清除密码指令
  sendRecOrder, //发送恢复出厂设置指令
  getClpOrderStatus,//获取清除密码指令状态
  getRecOrderStatus,//获取恢复出厂设置指令状态
  fileDistribution,//批量文件分发
  fileDistributionForGroups,//批量文件分发（针对设备组）
  handlerUninstallAppRevoke,//指令撤销

  appQueryThink,//按照应用名称和组名联想
  addAppApply,//审核申请
  cancelAppCheck,//撤销申请
  reAppCheck,//重新申请
  queryCheckMode,//查询审核模式
  queryCheckList,//查询审核列表
  queryAppInfo,//查询单个应用信息
  updateAppCheckStatus,//应用审核状态更新
  updateAppCheckMode,//应用审核模式切换
  queryAppCheckBlacklist,//查询应用审核黑名单列表
  addCheckBlacklist,//新增应用审核黑名单
  delCheckBlacklist,//删除应用黑名单
  listHasShelfApps,//查询已上架应用列表
  listNoShelfApps,//查询未上架应用列表
  appShelfToAll,//应用上架到全部分组
  appUnshelf,//应用下架
  appAndOrg,//查询应用与机构关系
  appShelfOrg,//应用按机构上架
  childOrgIds,//查询用户子机构
  appThinkQuery,//应用查询条件联想
  // appDownloadCount,//应用下载量查询
  listInsideApp,//内部应用查询
  editInsideApp,//编辑内部应用
  listHistoryInsideApp,//查询内部应用历史版本
  delInsideApp,//内部应用删除
  willDeployApp,//查询可以部署的应用
  queryAppDeploy1, // 获取应用部署的详情
  addAppDeploy,//新增应用部署
  updateAppDeploy,//更新应用部署
  listAppDeploy,//查询应用部署
  pushAppDeploy,//推送应用部署
  pushAppDeployBySnList,//推送应用部署
  delAppDeploy,//删除应用部署
  queryRecordDetail,//查询应用部署记录详情
  queryPushRange,//查询推送范围
  queryConfigProgress,//查询执行进度
  queryHasPushOrgIds,//查询配置已经推送的机构id
  //=======================penn end=========================
  notOnShelfApp,
  onShelfApp,
  onShelfAppForAppDeploy,
  batchOnShelfApp,
  batchUnShelfApp,
  autoInstallChange,
  getDvcAppInfo,
    getDeviceLifeCycleSum,
  getDeviceLifeCycleList,
  getListMyDeviceList,//获取我的设备列表
  queryDvcType,
  queryDeviceLogRecord,
  queryLogDevice,
  addDeviceLogRecord,
  updateDeviceLogRecordStatus,
  queryDeviceUploadLogFile,
  batchMoveDevice,
  countOnlineStatus,
  queryOccupyScreenApps,
  queryDeviceConfig,
  deviceConfigStart,
  addOrEditDeviceConfig,
  remoteWifiSetting,
  remoteWifiSettingForGroups,//wifi配置，针对设备组
  addOrEditRemark,
  bindTempDevice2,


  //设备厂商
  queryManufacturers,
  addManufacturerDvcType,
  addManufacturer,
  deleteManufacturerDvcType,
  deleteManufacturer,
  queryAllManufacturer,
  queryChildDvcType,

  //设备相关
  listOrgDevices,
  listOrgDevicesWithoutPage,
  deviceDetail,
  queryDeviceInfoDetail,
  queryDeviceHardwareDetections,
  queryDevicePower,
  queryDeviceInstalledApps,
  queryRecentDevicePower,
  queryOrgDeviceCount,


  //指令相关
  queryDeviceOrders,
  sendDeviceOrder,
  //查询设备状态
  queryDeviceStatus,
  //设备任务相关
  queryDeviceTaskLogs,
  //设备应用参数
  queryAppParam,
  addAppParamConfig,
  editAppParamConfig,
  queryCurrentParamConfig,
  pushParamConfig,
  pushParamConfigBySnList,
  getHasPushedOrganizations,
  getConfigRulePushRecord,
  getHasPushedOrgNames,
  getHasPushedSns,
  getHasPushedSnsWithoutPage,
  queryNotFinishSn,
  deleteAppParamConfig,

  //查询文件分发
  queryDistributionTable,
  addFileDistribution,
  editFileDistribution,
  pushFileDistributionConfig,
  pushFileDistributionBySnList,
  queryCurrentDistribution,
  deleteFileDistribution,
  deleteFunctionSetting,

  //功能设置
  queryFunctionSettings,
  addFunctionConfig,
  editFunctionConfig,
  pushFunctionSetting,
  pushFunctionSettingBySnList,



  addWifiConfig,
  queryWifiConfigById,
  queryWifiConfigList,
  getWifiName,
  editWifiConfig,
  delWifiConfig,
  listWifiPushGroup,
  batchPushWifiConfig,


  //apn
  queryApnSettingsList,
  addApnSetting,
  editApnSetting,
  pushApnSetting,
  queryApnPushedGroup,
  queryApnPushRangeByCode,
  deleteApnSettings,

  deviceGroupExport,
  addTempDeviceInGroup,
  exportBindTempDevice,
  switchDeviceForGroups,
  batchSaveDeviceConfig,

  dvcMessagePush,
  dvcMessagePushForGroups,
  dvcBootLogo,
  dvcBootLogoForGroups,
  // 应用管理

  editAppDeploy,
  deleteAppDeploy,
  queryHasDeployedApps,
  queryAppDeploy,
  queryAppDeployOperateRecord,
  queryPushRangeByCode,
  queryAppDeployHasPushedGroups,






  queryConfigUnFinshDeviceList,

  exportConfigUnFinshDeviceList,

  queryConfigPushDeviceGroupList,

  queryFcConfigUnFinshDeviceList,

  exportFcConfigUnFinshDeviceList,

  queryFcConfigPushDeviceGroupList,
  delFunctionConfig,


  //自定义桌面
  addCustomDesk,
  delCustomDesk,
  getHasPushGroups,
  showHasPushGroups,
  batchPushCusDesk,
  editCustomDesk,

  //  功能设置  ↓
  updateFunctionConfig,
  queryFcConfigList,
  pushFcConfig,
  getConfigPushGroup,

  //wifi白名单
  addWifiWhitelist,
  queryWifiWhiteList,
  delWifiWhiteList,
  queryWifiWhiteListByCode,
  editWifiWhitelist,
  listWifiWhitelistPushGroup,
  batchPushWifiWhitelistConfig,
  queryWifiWhitelistPushRanage,

  queryWifiWhitelistPushRanageByCompanyCode,

  queryGroupPushWifiSsid,

  queryGroupPushWifiSsidBySsidName,


  //流量管理
  flowUseListTable,
  exportCompanyFlow,
  queryAppFlowList,
  getAppAverage,
  exportAppFlow,
  flowUseListLine,
  getDvcGroupFlowAll,
  getDvcGroupFlowList,
  exportGroupFlow,
  getDvcGroupFlowListDetail,
  getDvcGroupFlowListDetailOne,
  exportDvcGroupFlowListDetailOne,


  //  身份登记报表
  getTemperatureInfo,

  // 获取机构树
  queryOrgAndSubOrg,
  // 创建子机构（商户）
  createOrgOrMerchant,
  // 获取机构（商户）详情
  queryOrgDetailById,
  // 保存机构（商户）修改
  updateOrgOrMerchant,
  // 删除机构（商户）
  deleteOrgById,

  // 设备入库、设备绑定、设备解绑
  // 设备入库
  addDeviceOne,
  // 获取指定机构的终端仓库中的设备
  queryRepositoryDevice,
  // 库存移动
  storageMove,
  // 设备绑定
  deviceBind,
  // 设备解绑
  unbindDevice,

  // 获取日志记录
  queryLog,
  // 获取日志筛选条件
  queryOptions,

  // 添加WIFI配置
  addWifiSetting,
  editWifiSetting,
  // 获取WIFI配置列表
  queryWifiSettingList,
  // 推送WIFI配置
  pushWifiSetting,
  pushWifiSettingBySnList,
  // 获取WIFI配置的推送范围
  queryWifiSettingPushRange,
  // 获取WIFI配置的推送完成情况
  queryFinishStatus,
  // 获取WIFI配置详情
  queryWifiConfigDetail,
  // 删除WIFI配置
  deleteWifiSetting,
  // 获取WIFI配置推送记录
  queryPushRecord,
  // 重新推送失败的配置
  rePush,

  // 添加APN配置
  addApnConfig,
  editApnConfig,
  // 获取APN配置列表
  queryApnConfigList,
  queryApnDetail,
  // APN配置推送
  pushApnConfig,
  pushApnConfigBySnList,
  // 删除APN配置
  deleteApnConfig,
  // 获取APN配置的推送范围
  queryApnConfigPushRange,
  // 获取APN配置完成情况
  queryApnFinishStatus,

  // 添加自定义桌面配置
  addCustomDeskConfig,
  // 获取自定义桌面配置列表
  queryCustomDeskConfigList,
  queryCustomDesk,
  // 获取自定义桌面配置的推送范围
  queryCustomDeskConfigPushRange,
  // 推送自定义桌面配置
  pushCustomDeskConfig,
  pushCustomDeskConfigBySnList,
  // 删除自定义桌面配置
  deleteCustomDeskConfig,
  // 获取自定义桌面配置的完成情况
  queryCustomDeskFinishStatus,

  //查询设备围栏
  queryDeviceFenceList,
  //获取已推送分组
  queryAlreadyPushOrg,
  //添加设备围栏
  addDeviceFence,
  //删除设备围栏
  deleteDeviceFence,
//推送设备围栏
  pushDeviceFence,
  pushDeviceFenceConfigBySnList,
  //获取设备围栏情况
  queryDeviceFenceFinishStatus,
  //编辑设备围栏
  editDeviceFence,


  //平台设置
  queryFlowAndPownerSetting,

  updateFlowAndPownerSetting,

  queryDataCacheSetting,
  updateDataCacheSetting,

  recordDownloadDeviceLog,

  // 批量删除设备
  deviceDeleteBash,

  operateDate,

  // 获取上传文件进度
  quryUploadProcess,
  // 是否开启了OSS文件上传
  ifUploadOss,
  //开机动画
  queryBootAnimation,
  updateBootAnimation,
  createBootAnimation,
  deleteBootAnimation,
  pushBootAnimation,
  pushBootAnimationBySnList
}

export default apiList



// WEBPACK FOOTER //
// ./src/api/api.js